/* constants.js */
const ON_CHANGE_DEBOUNCE_TIMER = 300

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error'
}

/* pubsub.js */
let subscribers = {}

function subscribe (eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = []
  }

  subscribers[eventName] = [...subscribers[eventName], callback]

  return function unsubscribe () {
    subscribers[eventName] = subscribers[eventName].filter(cb => {
      return cb !== callback
    })
  }
}

function publish (eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach(callback => {
      callback(data)
    })
  }
}

function getFocusableElements (container) {
  if(container) {
    return Array.from(
      container.querySelectorAll(
        "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
    )
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach(summary => {
  summary.setAttribute('role', 'button')
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'))

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id)
  }

  summary.addEventListener('click', event => {
    event.currentTarget.setAttribute(
      'aria-expanded',
      !event.currentTarget.closest('details').hasAttribute('open')
    )
  })

  if (summary.closest('menu-drawer')) return
  summary.parentElement.addEventListener('keyup', onKeyUpEscape)
})

const trapFocusHandlers = {}

function trapFocus (container, elementToFocus = container) {
  var elements = getFocusableElements(container)
  var first = elements[0]
  var last = elements[elements.length - 1]

  removeTrapFocus()

  trapFocusHandlers.focusin = event => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return

    document.addEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault()
      first.focus()
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault()
      last.focus()
    }
  }

  document.addEventListener('focusout', trapFocusHandlers.focusout)
  document.addEventListener('focusin', trapFocusHandlers.focusin)

  elementToFocus.focus()

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length)
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible')
} catch (e) {
  focusVisiblePolyfill()
}

function focusVisiblePolyfill () {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN'
  ]
  let currentFocusedElement = null
  let mouseClick = null

  window.addEventListener('keydown', event => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false
    }
  })

  window.addEventListener('mousedown', event => {
    mouseClick = true
  })

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove('focused')

      if (mouseClick) return

      currentFocusedElement = document.activeElement
      currentFocusedElement.classList.add('focused')
    },
    true
  )
}

function pauseAllMedia () {
  document.querySelectorAll('.js-youtube').forEach(video => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*'
    )
  })
  document.querySelectorAll('.js-vimeo').forEach(video => {
    video.contentWindow.postMessage('{"method":"pause"}', '*')
  })
  document.querySelectorAll('video').forEach(video => video.pause())
  document.querySelectorAll('product-model').forEach(model => {
    if (model.modelViewerUI) model.modelViewerUI.pause()
  })
}

function removeTrapFocus (elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin)
  document.removeEventListener('focusout', trapFocusHandlers.focusout)
  document.removeEventListener('keydown', trapFocusHandlers.keydown)

  if (elementToFocus) elementToFocus.focus()
}

function onKeyUpEscape (event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return

  const openDetailsElement = event.target.closest('details[open]')
  if (!openDetailsElement) return

  const summaryElement = openDetailsElement.querySelector('summary')
  openDetailsElement.removeAttribute('open')
  summaryElement.setAttribute('aria-expanded', false)
  summaryElement.focus()
}

class QuantityInput extends HTMLElement {
  constructor () {
    super()
    this.input = this.querySelector('input')
    this.changeEvent = new Event('change', { bubbles: true })
    this.input.addEventListener('change', this.onInputChange.bind(this))
    this.querySelectorAll('button').forEach(button =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    )
  }

  quantityUpdateUnsubscriber = undefined

  connectedCallback () {
    this.validateQtyRules()
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    )
  }

  disconnectedCallback () {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber()
    }
  }

  onInputChange (event) {
    this.validateQtyRules()
  }

  onButtonClick (event) {
    event.preventDefault()
    const previousValue = this.input.value

    if (event.target.name === 'plus') {
      if (
        parseInt(this.input.dataset.min) > parseInt(this.input.step) &&
        this.input.value == 0
      ) {
        this.input.value = this.input.dataset.min
      } else {
        this.input.stepUp()
      }
    } else {
      this.input.stepDown()
    }

    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent)

    if (
      this.input.dataset.min === previousValue &&
      event.target.name === 'minus'
    ) {
      this.input.value = parseInt(this.input.min)
    }
  }

  validateQtyRules () {
    const value = parseInt(this.input.value)
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']")
      buttonMinus.classList.toggle(
        'disabled',
        parseInt(value) <= parseInt(this.input.min)
      )
    }
    if (this.input.max) {
      const max = parseInt(this.input.max)
      const buttonPlus = this.querySelector(".quantity__button[name='plus']")
      buttonPlus.classList.toggle('disabled', value >= max)
    }
  }
}

customElements.define('quantity-input', QuantityInput)

function debounce (fn, wait) {
  let t
  return (...args) => {
    clearTimeout(t)
    t = setTimeout(() => fn.apply(this, args), wait)
  }
}

function throttle (fn, delay) {
  let lastCall = 0
  return function (...args) {
    const now = new Date().getTime()
    if (now - lastCall < delay) {
      return
    }
    lastCall = now
    return fn(...args)
  }
}

function fetchConfig (type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`
    }
  }
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {}
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments)
  }
}

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i]
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i
      return i
    }
  }
}

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback)
}

Shopify.postLink = function (path, options) {
  options = options || {}
  var method = options['method'] || 'post'
  var params = options['parameters'] || {}

  var form = document.createElement('form')
  form.setAttribute('method', method)
  form.setAttribute('action', path)

  for (var key in params) {
    var hiddenField = document.createElement('input')
    hiddenField.setAttribute('type', 'hidden')
    hiddenField.setAttribute('name', key)
    hiddenField.setAttribute('value', params[key])
    form.appendChild(hiddenField)
  }
  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
}

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid)
  this.provinceEl = document.getElementById(province_domid)
  this.provinceContainer = document.getElementById(
    options['hideElement'] || province_domid
  )

  Shopify.addListener(
    this.countryEl,
    'change',
    Shopify.bind(this.countryHandler, this)
  )

  this.initCountry()
  this.initProvince()
}

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default')
    Shopify.setSelectorByValue(this.countryEl, value)
    this.countryHandler()
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default')
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value)
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex]
    var raw = opt.getAttribute('data-provinces')
    var provinces = JSON.parse(raw)

    this.clearOptions(this.provinceEl)
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none'
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option')
        opt.value = provinces[i][0]
        opt.innerHTML = provinces[i][1]
        this.provinceEl.appendChild(opt)
      }

      this.provinceContainer.style.display = ''
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild)
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option')
      opt.value = values[i]
      opt.innerHTML = values[i]
      selector.appendChild(opt)
    }
  }
}

class MenuDrawer extends HTMLElement {
  constructor () {
    super()

    this.mainDetailsToggle = this.querySelector('details')

    this.addEventListener('keyup', this.onKeyUp.bind(this))
    this.addEventListener('focusout', this.onFocusOut.bind(this))
    this.bindEvents()
  }

  bindEvents () {
    this.querySelectorAll('summary').forEach(summary =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    )
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button):not(.menu-drawer__accordion-opener)'
    ).forEach(button =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    )
  }

  onKeyUp (event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return

    const openDetailsElement = event.target.closest('details[open]')
    if (!openDetailsElement) return

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector('summary')
        )
      : this.closeSubmenu(openDetailsElement)
  }

  onSummaryClick (event) {
    const summaryElement = event.currentTarget
    const detailsElement = summaryElement.parentNode
    const parentMenuElement = detailsElement.closest('.has-submenu')
    const isOpen = detailsElement.hasAttribute('open')
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')

    function addTrapFocus () {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector('button')
      )
      summaryElement.nextElementSibling.removeEventListener(
        'transitionend',
        addTrapFocus
      )
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault()
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement)

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty(
          '--viewport-height',
          `${window.innerHeight}px`
        )
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening')
        summaryElement.setAttribute('aria-expanded', true)
        parentMenuElement && parentMenuElement.classList.add('submenu-open')
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              'transitionend',
              addTrapFocus
            )
      }, 100)
    }
  }

  openMenuDrawer (summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening')
    })
    summaryElement.setAttribute('aria-expanded', true)
    trapFocus(this.mainDetailsToggle, summaryElement)
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
  }

  closeMenuDrawer (event, elementToFocus = false) {
    if (event === undefined) return

    this.mainDetailsToggle.classList.remove('menu-opening')
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open')
      details.classList.remove('menu-opening')
    })
    this.mainDetailsToggle
      .querySelectorAll('.submenu-open')
      .forEach(submenu => {
        submenu.classList.remove('submenu-open')
      })
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`)
    removeTrapFocus(elementToFocus)
    this.closeAnimation(this.mainDetailsToggle)

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute('aria-expanded', false)
  }

  onFocusOut () {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute('open') &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer()
    })
  }

  onCloseButtonClick (event) {
    const detailsElement = event.currentTarget.closest('details')
    this.closeSubmenu(detailsElement)
  }

  closeSubmenu (detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open')
    parentMenuElement && parentMenuElement.classList.remove('submenu-open')
    detailsElement.classList.remove('menu-opening')
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false)
    removeTrapFocus(detailsElement.querySelector('summary'))
    this.closeAnimation(detailsElement)
  }

  closeAnimation (detailsElement) {
    let animationStart

    const handleAnimation = time => {
      if (animationStart === undefined) {
        animationStart = time
      }

      const elapsedTime = time - animationStart

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation)
      } else {
        detailsElement.removeAttribute('open')
        if (detailsElement.closest('details[open]')) {
          trapFocus(
            detailsElement.closest('details[open]'),
            detailsElement.querySelector('summary')
          )
        }
      }
    }

    window.requestAnimationFrame(handleAnimation)
  }
}

customElements.define('menu-drawer', MenuDrawer)

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor () {
    super()
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    )
    this.addEventListener('keyup', event => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide()
    })
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', event => {
        if (
          event.pointerType === 'mouse' &&
          !event.target.closest('deferred-media, product-model')
        )
          this.hide()
      })
    } else {
      this.addEventListener('click', event => {
        if (event.target === this) this.hide()
      })
    }
  }

  connectedCallback () {
    if (this.moved) return
    this.moved = true
    document.body.appendChild(this)
  }

  show (opener) {
    this.openedBy = opener
    const popup = this.querySelector('.template-popup')
    document.body.classList.add('overflow-hidden')
    this.setAttribute('open', '')
    if (popup) popup.loadContent()
    trapFocus(this, this.querySelector('[role="dialog"]'))
    window.pauseAllMedia()
  }

  hide () {
    document.body.classList.remove('overflow-hidden')
    document.body.dispatchEvent(new CustomEvent('modalClosed'))
    this.removeAttribute('open')
    removeTrapFocus(this.openedBy)
    window.pauseAllMedia()
  }
}
customElements.define('modal-dialog', ModalDialog)

class ModalOpener extends HTMLElement {
  constructor () {
    super();

    const button = this.querySelector('button');

    if (!button) return;

    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener)

class DeferredMedia extends HTMLElement {
  constructor () {
    super()
    const poster = this.querySelector('[id^="Deferred-Poster-"]')
    if (!poster) return
    poster.addEventListener('click', this.loadContent.bind(this))
  }

  loadContent (focus = true) {
    window.pauseAllMedia()
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div')
      content.appendChild(
        this.querySelector('template').content.firstElementChild.cloneNode(true)
      )

      this.setAttribute('loaded', true)
      const deferredElement = this.appendChild(
        content.querySelector('video, model-viewer, iframe')
      )
      if (focus) deferredElement.focus()
      if (
        deferredElement.nodeName == 'VIDEO' &&
        deferredElement.getAttribute('autoplay')
      ) {
        // force autoplay for safari
        deferredElement.play()
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia)

class VariantSelects extends HTMLElement {
  constructor () {
    super()
    this.addEventListener('change', this.onVariantChange)
  }

  onVariantChange (event) {
    this.updateOptions()
    this.updateMasterId()
    this.updateSelectedSwatchValue(event)
    this.toggleAddButton(true, '', false)
    this.updatePickupAvailability()
    this.removeErrorMessage()
    this.updateVariantStatuses()

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true)
      this.setUnavailable()
    } else {
      this.updateURL()
      this.updateVariantInput()
      this.renderProductInfo()
      this.updateShareUrl()
    }
  }

  updateOptions () {
    this.options = Array.from(
      this.querySelectorAll('select, fieldset'),
      element => {
        if (element.tagName === 'SELECT') {
          return element.value
        }
        if (element.tagName === 'FIELDSET') {
          return Array.from(element.querySelectorAll('input')).find(
            radio => radio.checked
          )?.value
        }
      }
    )
  }

  updateMasterId () {
    this.currentVariant = this.getVariantData().find(variant => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option
        })
        .includes(false)
    })
  }

  updateSelectedSwatchValue ({ target }) {
    const { name, value, tagName } = target

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue
      const selectedDropdownSwatchValue = this.querySelector(
        `[data-selected-dropdown-swatch="${name}"] > .swatch`
      )
      if (!selectedDropdownSwatchValue) return
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty(
          '--swatch--background',
          swatchValue
        )
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable')
      } else {
        selectedDropdownSwatchValue.style.setProperty(
          '--swatch--background',
          'unset'
        )
        selectedDropdownSwatchValue.classList.add('swatch--unavailable')
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      )
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(
        `[data-selected-swatch-value="${name}"]`
      )
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value
    }
  }

  updateURL () {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    )
  }

  updateShareUrl () {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`)
    if (!shareButton || !shareButton.updateUrl) return
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    )
  }

  updateVariantInput () {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    )
    productForms.forEach(productForm => {
      const input = productForm.querySelector('input[name="id"]')
      input.value = this.currentVariant.id
      input.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }

  updateVariantStatuses () {
    const selectedOptionOneVariants = this.variantData.filter(
      variant => this.querySelector(':checked').value === variant.option1
    )
    const inputWrappers = [...this.querySelectorAll('.product-form__input')]
    inputWrappers.forEach((option, index) => {
      if (index === 0) return
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option')
      ]
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(':checked').value
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          variant =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map(variantOption => variantOption[`option${index + 1}`])
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    })
  }

  setInputAvailability (elementList, availableValuesList) {
    elementList.forEach(element => {
      const value = element.getAttribute('value')
      const availableElement = availableValuesList.includes(value)

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement)
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace(
              '[value]',
              value
            )
      }
    })
  }

  updatePickupAvailability () {
    const pickUpAvailability = document.querySelector('pickup-availability')
    if (!pickUpAvailability) return

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id)
    } else {
      pickUpAvailability.removeAttribute('available')
      pickUpAvailability.innerHTML = ''
    }
  }

  removeErrorMessage () {
    const section = this.closest('section')
    if (!section) return

    const productForm = section.querySelector('product-form')
    if (productForm) productForm.handleErrorMessage()
  }

  updateMedia (html) {
    const mediaGallerySource = document.querySelector(
      `[id^="MediaGallery-${this.dataset.section}"] ul`
    )
    const mediaGalleryDestination = html.querySelector(
      `[id^="MediaGallery-${this.dataset.section}"] ul`
    )

    const refreshSourceData = () => {
      const mediaGallerySourceItems = Array.from(
        mediaGallerySource.querySelectorAll('li[data-media-id]')
      )
      const sourceSet = new Set(
        mediaGallerySourceItems.map(item => item.dataset.mediaId)
      )
      const sourceMap = new Map(
        mediaGallerySourceItems.map((item, index) => [
          item.dataset.mediaId,
          { item, index }
        ])
      )
      return [mediaGallerySourceItems, sourceSet, sourceMap]
    }

    if (mediaGallerySource && mediaGalleryDestination) {
      let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData()
      const mediaGalleryDestinationItems = Array.from(
        mediaGalleryDestination.querySelectorAll('li[data-media-id]')
      )
      const destinationSet = new Set(
        mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId)
      )
      let shouldRefresh = false

      // add items from new data not present in DOM
      for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
        if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
          mediaGallerySource.prepend(mediaGalleryDestinationItems[i])
          shouldRefresh = true
        }
      }

      // remove items from DOM not present in new data
      for (let i = 0; i < mediaGallerySourceItems.length; i++) {
        if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
          mediaGallerySourceItems[i].remove()
          shouldRefresh = true
        }
      }

      // refresh
      if (shouldRefresh)
        [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData()

      // if media galleries don't match, sort to match new data order
      mediaGalleryDestinationItems.forEach(
        (destinationItem, destinationIndex) => {
          const sourceData = sourceMap.get(destinationItem.dataset.mediaId)

          if (sourceData && sourceData.index !== destinationIndex) {
            mediaGallerySource.insertBefore(
              sourceData.item,
              mediaGallerySource.querySelector(
                `li:nth-of-type(${destinationIndex + 1})`
              )
            )

            // refresh source now that it has been modified
            ;[mediaGallerySourceItems, sourceSet, sourceMap] =
              refreshSourceData()
          }
        }
      )
    }

    if (this.currentVariant.featured_media) {
      document
        .querySelector(`[id^="MediaGallery-${this.dataset.section}"]`)
        ?.setActiveMedia?.(
          `${this.dataset.section}-${this.currentVariant.featured_media.id}`
        )
    }

    // update media modal
    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    )
    const newModalContent = html.querySelector(`product-modal`)
    if (modalContent && newModalContent)
      modalContent.innerHTML = newModalContent.innerHTML
  }

  renderProductInfo () {
    const requestedVariantId = this.currentVariant.id
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then(response => response.text())
      .then(responseText => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        )
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        )
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        )
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        )
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        )
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        )

        const volumePricingSource = html.getElementById(
          `Volume-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        )

        this.updateMedia(html)

        const pricePerItemDestination = document.getElementById(
          `Price-Per-Item-${this.dataset.section}`
        )
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        )

        const volumePricingDestination = document.getElementById(
          `Volume-${this.dataset.section}`
        )
        const qtyRules = document.getElementById(
          `Quantity-Rules-${this.dataset.section}`
        )
        const volumeNote = document.getElementById(
          `Volume-Note-${this.dataset.section}`
        )

        if (volumeNote) volumeNote.classList.remove('hidden')
        if (volumePricingDestination)
          volumePricingDestination.classList.remove('hidden')
        if (qtyRules) qtyRules.classList.remove('hidden')

        if (source && destination) destination.innerHTML = source.innerHTML
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML
          skuDestination.classList.toggle(
            'hidden',
            skuSource.classList.contains('hidden')
          )
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML
          pricePerItemDestination.classList.toggle(
            'hidden',
            pricePerItemSource.classList.contains('hidden')
          )
        }

        const price = document.getElementById(`price-${this.dataset.section}`)

        if (price) price.classList.remove('hidden')

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            'hidden',
            inventorySource.innerText === ''
          )

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        )
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        )

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant
          }
        })
      })
  }

  toggleAddButton (disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    )
    if (!productForm) return
    const addButton = productForm.querySelector('[name="add"]')
    const addButtonText = productForm.querySelector('[name="add"] > span')
    if (!addButton) return

    if (disable) {
      addButton.setAttribute('disabled', 'disabled')
      if (text) addButtonText.textContent = text
    } else {
      addButton.removeAttribute('disabled')
      addButtonText.textContent = window.variantStrings.addToCart
    }

    if (!modifyClass) return
  }

  setUnavailable () {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    )
    const addButton = button.querySelector('[name="add"]')
    const addButtonText = button.querySelector('[name="add"] > span')
    const price = document.getElementById(`price-${this.dataset.section}`)
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    )
    const sku = document.getElementById(`Sku-${this.dataset.section}`)
    const pricePerItem = document.getElementById(
      `Price-Per-Item-${this.dataset.section}`
    )
    const volumeNote = document.getElementById(
      `Volume-Note-${this.dataset.section}`
    )
    const volumeTable = document.getElementById(
      `Volume-${this.dataset.section}`
    )
    const qtyRules = document.getElementById(
      `Quantity-Rules-${this.dataset.section}`
    )

    if (!addButton) return
    addButtonText.textContent = window.variantStrings.unavailable
    if (price) price.classList.add('hidden')
    if (inventory) inventory.classList.add('hidden')
    if (sku) sku.classList.add('hidden')
    if (pricePerItem) pricePerItem.classList.add('hidden')
    if (volumeNote) volumeNote.classList.add('hidden')
    if (volumeTable) volumeTable.classList.add('hidden')
    if (qtyRules) qtyRules.classList.add('hidden')
  }

  getVariantData () {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent)
    return this.variantData
  }
}

customElements.define('variant-selects', VariantSelects)

class ProductRecommendations extends HTMLElement {
  constructor () {
    super()
  }

  connectedCallback () {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return
      observer.unobserve(this)

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div')
          html.innerHTML = text
          const recommendations = html.querySelector('product-recommendations')

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML
          }

          if (
            !this.querySelector('slideshow-component') &&
            this.classList.contains('complementary-products')
          ) {
            this.remove()
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded')
          }
        })
        .catch(e => {
          console.error(e)
        })
    }

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 400px 0px'
    }).observe(this)
  }
}

customElements.define('product-recommendations', ProductRecommendations)

class AccountIcon extends HTMLElement {
  constructor () {
    super()

    this.icon = this.querySelector('.icon')
  }

  connectedCallback () {
    document.addEventListener(
      'storefront:signincompleted',
      this.handleStorefrontSignInCompleted.bind(this)
    )
  }

  handleStorefrontSignInCompleted (event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode())
    }
  }
}

customElements.define('account-icon', AccountIcon)

/* animations.js */
const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger'
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen'
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in'
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel'

// Scroll in animation logic
function onIntersection (elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target
      if (
        elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)
      ) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`)
      }
      observer.unobserve(elementTarget)
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME)
    }
  })
}

function initializeScrollAnimationTrigger (
  rootEl = document,
  isDesignModeEvent = false
) {
  const animationTriggerElements = Array.from(
    rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME)
  )
  if (animationTriggerElements.length === 0) return

  if (isDesignModeEvent) {
    animationTriggerElements.forEach(element => {
      element.classList.add('scroll-trigger--design-mode')
    })
    return
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px'
  })
  animationTriggerElements.forEach(element => observer.observe(element))
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

  const animationTriggerElements = Array.from(
    document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME)
  )

  if (animationTriggerElements.length === 0) return

  const scaleAmount = 0.2 / 100

  animationTriggerElements.forEach(element => {
    let elementIsVisible = false
    const observer = new IntersectionObserver(elements => {
      elements.forEach(entry => {
        elementIsVisible = entry.isIntersecting
      })
    })
    observer.observe(element)

    element.style.setProperty(
      '--zoom-in-ratio',
      1 + scaleAmount * percentageSeen(element)
    )

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return

        element.style.setProperty(
          '--zoom-in-ratio',
          1 + scaleAmount * percentageSeen(element)
        )
      }),
      { passive: true }
    )
  })
}

function percentageSeen (element) {
  const viewportHeight = window.innerHeight
  const scrollY = window.scrollY
  const elementPositionY = element.getBoundingClientRect().top + scrollY
  const elementHeight = element.offsetHeight

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY
  let percentage = distance / ((viewportHeight + elementHeight) / 100)
  return Math.round(percentage)
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger()
  initializeScrollZoomAnimationTrigger()
})

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', event =>
    initializeScrollAnimationTrigger(event.target, true)
  )
  document.addEventListener('shopify:section:reorder', () =>
    initializeScrollAnimationTrigger(document, true)
  )
}

/* cart-drawer.js */
class CartDrawer extends HTMLElement {
  constructor () {
    super()

    this.addEventListener('keyup', evt => evt.code === 'Escape' && this.close())
    this.querySelector('#CartDrawer-Overlay').addEventListener(
      'click',
      this.close.bind(this)
    )
    this.setHeaderCartIconAccessibility()
  }

  setHeaderCartIconAccessibility () {
    const cartLink = document.querySelector('#cart-icon-bubble')
    cartLink.setAttribute('role', 'button')
    cartLink.setAttribute('aria-haspopup', 'dialog')
    cartLink.addEventListener('click', event => {
      event.preventDefault()
      this.open(cartLink)
    })
    cartLink.addEventListener('keydown', event => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault()
        this.open(cartLink)
      }
    })
  }

  open (triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy)
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary')
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role'))
      this.setSummaryAccessibility(cartDrawerNote)
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active')
    })

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer')
        const focusElement =
          this.querySelector('.drawer__inner') ||
          this.querySelector('.drawer__close')
        trapFocus(containerToTrapFocusOn, focusElement)
      },
      { once: true }
    )

    document.body.classList.add('overflow-hidden')
  }

  close () {
    this.classList.remove('active')
    removeTrapFocus(this.activeElement)
    document.body.classList.remove('overflow-hidden')
  }

  setSummaryAccessibility (cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button')
    cartDrawerNote.setAttribute('aria-expanded', 'false')

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute(
        'aria-controls',
        cartDrawerNote.nextElementSibling.id
      )
    }

    cartDrawerNote.addEventListener('click', event => {
      event.currentTarget.setAttribute(
        'aria-expanded',
        !event.currentTarget.closest('details').hasAttribute('open')
      )
    })

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape)
  }

  renderContents (parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty')
    this.productId = parsedState.id
    this.getSectionsToRender().forEach(section => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id)
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      )
    })

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener(
        'click',
        this.close.bind(this)
      )
      this.open()
    })
  }

  getSectionInnerHTML (html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML
  }

  getSectionsToRender () {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ]
  }

  getSectionDOM (html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector)
  }

  setActiveElement (element) {
    this.activeElement = element
  }
}

customElements.define('cart-drawer', CartDrawer)

class CartItems extends HTMLElement {
  constructor () {
    super()
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') ||
      document.getElementById('CartDrawer-LineItemStatus')

    const debouncedOnChange = debounce(event => {
      this.onChange(event)
    }, ON_CHANGE_DEBOUNCE_TIMER)

    this.addEventListener('change', debouncedOnChange.bind(this))
  }

  cartUpdateUnsubscriber = undefined

  connectedCallback () {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      event => {
        if (event.source === 'cart-items') {
          return
        }
        this.onCartUpdate()
      }
    )
  }

  disconnectedCallback () {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber()
    }
  }

  onChange (event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name'),
      event.target.dataset.quantityVariantId
    )
  }

  onCartUpdate () {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then(response => response.text())
        .then(responseText => {
          const html = new DOMParser().parseFromString(
            responseText,
            'text/html'
          )
          const selectors = ['cart-drawer-items', '.cart-drawer__footer']
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector)
            const sourceElement = html.querySelector(selector)
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement)
            }
          }
        })
        .catch(e => {
          console.error(e)
        })
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart`)
        .then(response => response.text())
        .then(responseText => {
          const html = new DOMParser().parseFromString(
            responseText,
            'text/html'
          )
          const sourceQty = html.querySelector('cart-items')
          this.innerHTML = sourceQty.innerHTML
        })
        .catch(e => {
          console.error(e)
        })
    }
  }

  getSectionsToRender () {
    return [
      {
        id: 'main-cart',
        section: document.getElementById('main-cart').dataset.id,
        selector: '.main-cart--title'
      },
      {
        id: 'main-cart',
        section: document.getElementById('main-cart').dataset.id,
        selector: '.cart--items .cart--items__content'
      },
      {
        id: 'main-cart',
        section: document.getElementById('main-cart').dataset.id,
        selector: '.cart--footer .cart--footer__content'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      }
    ]
  }

  updateQuantity (line, quantity, name, variantId) {
    this.enableLoading(line)

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map(section => section.section).filter((v, i, a) => a.indexOf(v) === i),
      sections_url: window.location.pathname
    })

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then(response => {
        return response.text()
      })
      .then(state => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`)
        const items = document.querySelectorAll('.cart-item')

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value')
          this.updateLiveRegions(line, parsedState.errors)
          return
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0)

        document.getElementById('main-cart')?.classList.toggle('is-empty', parsedState.item_count === 0);

        const cartDrawerWrapper = document.querySelector('cart-drawer')
        const cartFooter = document.getElementById('main-cart')?.querySelector('.cart--footer');

        if (cartFooter)
          cartFooter.classList.toggle('is-empty', parsedState.item_count === 0)
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            'is-empty',
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach(section => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id)

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          )
        })
        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined
        let message = ''
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error
          } else {
            message = window.cartStrings.quantityError.replace(
              '[quantity]',
              updatedValue
            )
          }
        }
        this.updateLiveRegions(line, message)

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`)
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`)
              )
            : lineItem.querySelector(`[name="${name}"]`).focus()
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector('.drawer__inner-empty'),
            cartDrawerWrapper.querySelector('a')
          )
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector('.cart-item__name')
          )
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-items',
          cartData: parsedState,
          variantId: variantId
        })
      })
      .catch((error) => {
        console.log(error);
        this.querySelectorAll('.loading__spinner').forEach(overlay =>
          overlay.classList.add('hidden')
        )
        const errors =
          document.getElementById('cart-errors') ||
          document.getElementById('CartDrawer-CartErrors')
        errors.textContent = window.cartStrings.error
      })
      .finally(() => {
        this.disableLoading(line)
      })
  }

  updateLiveRegions (line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`)
    if (lineItemError)
      lineItemError.querySelector('.cart-item__error-text').innerHTML = message

    this.lineItemStatusElement.setAttribute('aria-hidden', true)

    const cartStatus =
      document.getElementById('cart-live-region-text') ||
      document.getElementById('CartDrawer-LiveRegionText')
    cartStatus.setAttribute('aria-hidden', false)

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true)
    }, 1000)
  }

  getSectionInnerHTML (html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML
  }

  enableLoading (line) {
    const mainCartItems =
      document.getElementById('main-cart') ||
      document.getElementById('CartDrawer-CartItems')
    mainCartItems.classList.add('cart__items--disabled')

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    )
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    )

    ;[...cartItemElements, ...cartDrawerItemElements].forEach(overlay =>
      overlay.classList.remove('hidden')
    )

    document.activeElement.blur()
    this.lineItemStatusElement.setAttribute('aria-hidden', false)
  }

  disableLoading (line) {
    const mainCartItems =
      document.getElementById('main-cart') ||
      document.getElementById('CartDrawer-CartItems')
    mainCartItems.classList.remove('cart__items--disabled')

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    )
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    )

    cartItemElements.forEach(overlay => overlay.classList.add('hidden'))
    cartDrawerItemElements.forEach(overlay => overlay.classList.add('hidden'))
  }
}

customElements.define('cart-items', CartItems)

class CartDrawerItems extends CartItems {
  getSectionsToRender () {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ]
  }

  mergedSectionsToRender() {
    const sections = this.getSectionsToRender();
    if (document.getElementById('main-cart')) {
      return sections.concat(super.getSectionsToRender());
    }

    return sections;
  }

  swapOrAddGiftWrapper(giftId, giftTitle, giftList) {
    let updates = {};
    for (const gift of giftList) {
      updates[gift] = 0;
    }

    const body = JSON.stringify({
      updates,
      sections: this.mergedSectionsToRender().map(section => section.section).filter((v, i, a) => a.indexOf(v) === i),
      sections_url: window.location.pathname
    })

    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then(response => {
        return response.text()
      })
      .then(state => {
        const parsedState = JSON.parse(state);
        if (parsedState.errors) {
          console.log('Failed to delete gift wrappers');
          console.error(parsedState.errors);
          return;
        }

        this.addGift(giftId, giftTitle);
      })
      .catch((error) => {
        console.log(error);
        this.querySelectorAll('.loading__spinner').forEach(overlay =>
          overlay.classList.add('hidden')
        )
        const errors =
          document.getElementById('cart-errors') ||
          document.getElementById('CartDrawer-CartErrors')
        errors.textContent = window.cartStrings.error
      });
  }

  addGiftWrapper(giftId, giftTitle) {
    let items = [
      {
        'id': giftId,
        'quantity': 1,
        'properties': {
          '_giftwrapping': giftTitle.split(' - ').pop().trim()
        }
      }
    ];

    const body = JSON.stringify({
      items,
      sections: this.mergedSectionsToRender().map(section => section.section).filter((v, i, a) => a.indexOf(v) === i),
      sections_url: window.location.pathname
    });
    
    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
      .then(response => {
        return response.text()
      })
      .then(state => {
        const parsedState = JSON.parse(state);
        if (parsedState.errors) {
          console.log('failed to add things');
          console.error(parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0)

        document.getElementById('main-cart')?.classList.toggle('is-empty', parsedState.item_count === 0);

        this.mergedSectionsToRender().forEach(section => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id)

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          )
        })

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-items',
          cartData: parsedState,
          variantId: giftId
        })
      })
      .catch((error) => {
        console.log(error);
        this.querySelectorAll('.loading__spinner').forEach(overlay =>
          overlay.classList.add('hidden')
        )
        const errors =
          document.getElementById('cart-errors') ||
          document.getElementById('CartDrawer-CartErrors')
        errors.textContent = window.cartStrings.error
      });
  } 
}

customElements.define('cart-drawer-items', CartDrawerItems)

/* cart-notification.js */
class CartNotification extends HTMLElement {
  constructor () {
    super()

    this.notification = document.getElementById('cart-notification')
    this.header = document.querySelector('sticky-header')
    this.onBodyClick = this.handleBodyClick.bind(this)

    this.notification.addEventListener(
      'keyup',
      evt => evt.code === 'Escape' && this.close()
    )
    this.querySelectorAll('button[type="button"]').forEach(closeButton =>
      closeButton.addEventListener('click', this.close.bind(this))
    )
  }

  open () {
    this.notification.classList.add('animate', 'active')

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus()
        trapFocus(this.notification)
      },
      { once: true }
    )

    document.body.addEventListener('click', this.onBodyClick)
  }

  close () {
    this.notification.classList.remove('active')
    document.body.removeEventListener('click', this.onBodyClick)

    removeTrapFocus(this.activeElement)
  }

  renderContents (parsedState) {
    this.cartItemKey = parsedState.key
    this.getSectionsToRender().forEach(section => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      )
    })

    if (this.header) this.header.reveal()
    this.open()
  }

  getSectionsToRender () {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ]
  }

  getSectionInnerHTML (html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML
  }

  handleBodyClick (evt) {
    const target = evt.target
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu')
      this.activeElement = disclosure
        ? disclosure.querySelector('summary')
        : null
      this.close()
    }
  }

  setActiveElement (element) {
    this.activeElement = element
  }
}

customElements.define('cart-notification', CartNotification)

/* cart.js */
class CartRemoveButton extends HTMLElement {
  constructor () {
    super()

    this.addEventListener('click', event => {
      event.preventDefault()
      const cartItems =
        this.closest('cart-items') || this.closest('cart-drawer-items')
      cartItems.updateQuantity(this.dataset.index, 0)
    })
  }
}

customElements.define('cart-remove-button', CartRemoveButton)

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor () {
        super()

        this.addEventListener(
          'input',
          debounce(event => {
            const body = JSON.stringify({ note: event.target.value })
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body }
            })
          }, ON_CHANGE_DEBOUNCE_TIMER)
        )
      }
    }
  )
}

/* customer.js */
const selectors = {
  customerAddresses: '[data-customer-addresses]',
  addressCountrySelect: '[data-address-country-select]',
  addressContainer: '[data-address]',
  toggleAddressButton: 'button[aria-expanded]',
  cancelAddressButton: 'button[type="reset"]',
  deleteAddressButton: 'button[data-confirm-message]'
}

const attributes = {
  expanded: 'aria-expanded',
  confirmMessage: 'data-confirm-message'
}

class CustomerAddresses {
  constructor () {
    this.elements = this._getElements()
    if (Object.keys(this.elements).length === 0) return
    this._setupCountries()
    this._setupEventListeners()
  }

  _getElements () {
    const container = document.querySelector(selectors.customerAddresses)
    return container
      ? {
          container,
          addressContainer: container.querySelector(selectors.addressContainer),
          toggleButtons: document.querySelectorAll(
            selectors.toggleAddressButton
          ),
          cancelButtons: container.querySelectorAll(
            selectors.cancelAddressButton
          ),
          deleteButtons: container.querySelectorAll(
            selectors.deleteAddressButton
          ),
          countrySelects: container.querySelectorAll(
            selectors.addressCountrySelect
          )
        }
      : {}
  }

  _setupCountries () {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(
        'AddressCountryNew',
        'AddressProvinceNew',
        {
          hideElement: 'AddressProvinceContainerNew'
        }
      )
      this.elements.countrySelects.forEach(select => {
        const formId = select.dataset.formId
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(
          `AddressCountry_${formId}`,
          `AddressProvince_${formId}`,
          {
            hideElement: `AddressProvinceContainer_${formId}`
          }
        )
      })
    }
  }

  _setupEventListeners () {
    this.elements.toggleButtons.forEach(element => {
      element.addEventListener('click', this._handleAddEditButtonClick)
    })
    this.elements.cancelButtons.forEach(element => {
      element.addEventListener('click', this._handleCancelButtonClick)
    })
    this.elements.deleteButtons.forEach(element => {
      element.addEventListener('click', this._handleDeleteButtonClick)
    })
  }

  _toggleExpanded (target) {
    target.setAttribute(
      attributes.expanded,
      (target.getAttribute(attributes.expanded) === 'false').toString()
    )
  }

  _handleAddEditButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(currentTarget)
  }

  _handleCancelButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(
      currentTarget
        .closest(selectors.addressContainer)
        .querySelector(`[${attributes.expanded}]`)
    )
  }

  _handleDeleteButtonClick = ({ currentTarget }) => {
    // eslint-disable-next-line no-alert
    if (confirm(currentTarget.getAttribute(attributes.confirmMessage))) {
      Shopify.postLink(currentTarget.dataset.target, {
        parameters: { _method: 'delete' }
      })
    }
  }
}

/* details-disclosure.js */
class DetailsDisclosure extends HTMLElement {
  constructor () {
    super()
    this.mainDetailsToggle = this.querySelector('details')
    this.content =
      this.mainDetailsToggle.querySelector('summary').nextElementSibling

    this.mainDetailsToggle.addEventListener(
      'focusout',
      this.onFocusOut.bind(this)
    )
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this))
  }

  onFocusOut () {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close()
    })
  }

  onToggle () {
    if (!this.animations) this.animations = this.content.getAnimations()

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play())
    } else {
      this.animations.forEach(animation => animation.cancel())
    }
  }

  close () {
    this.mainDetailsToggle.removeAttribute('open')
    this.mainDetailsToggle
      .querySelector('summary')
      .setAttribute('aria-expanded', false)
  }
}

customElements.define('details-disclosure', DetailsDisclosure)

class HeaderMenu extends DetailsDisclosure {
  constructor () {
    super()
    this.header = document.querySelector('.header-wrapper')
  }

  onToggle () {
    if (!this.header) return
    this.header.preventHide = this.mainDetailsToggle.open

    if (
      document.documentElement.style.getPropertyValue(
        '--header-bottom-position-desktop'
      ) !== ''
    )
      return
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    )
  }
}

customElements.define('header-menu', HeaderMenu)

/* details-modal.js */
class DetailsModal extends HTMLElement {
  constructor () {
    super()
    this.detailsContainer = this.querySelector('details')
    this.summaryToggle = this.querySelector('summary')

    this.detailsContainer.addEventListener(
      'keyup',
      event => event.code.toUpperCase() === 'ESCAPE' && this.close()
    )
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this))
    if (this.querySelector('button[type="button"]')) {
      this.querySelector('button[type="button"]').addEventListener(
        'click',
        this.close.bind(this)
      )
    }

    this.summaryToggle.setAttribute('role', 'button')
  }

  isOpen () {
    return this.detailsContainer.hasAttribute('open')
  }

  onSummaryClick (event) {
    event.preventDefault()
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event)
  }

  onBodyClick (event) {
    if (
      !this.contains(event.target) ||
      event.target.classList.contains('modal-overlay')
    )
      this.close(false)
  }

  open (event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this)
    event.target.closest('details').setAttribute('open', true)
    document.body.addEventListener('click', this.onBodyClickEvent)
    document.body.classList.add('overflow-hidden')

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    )
  }

  close (focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null)
    this.detailsContainer.removeAttribute('open')
    document.body.removeEventListener('click', this.onBodyClickEvent)
    document.body.classList.remove('overflow-hidden')
  }
}

customElements.define('details-modal', DetailsModal)

/* facets.js */
class FacetFiltersForm extends HTMLElement {
  constructor () {
    super()
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this)

    this.debouncedOnSubmit = debounce(event => {
      this.onSubmitHandler(event)
    }, 800)

    const facetForm = this.querySelector('form')
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this))

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop')
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape)
  }

  static setListeners () {
    const onHistoryChange = event => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial
      if (searchParams === FacetFiltersForm.searchParamsPrev) return
      FacetFiltersForm.renderPage(searchParams, null, false)
    }
    window.addEventListener('popstate', onHistoryChange)
  }

  static toggleActiveFacets (disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach(element => {
      element.classList.toggle('disabled', disable)
    })
  }

  static renderPage (searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams
    const sections = FacetFiltersForm.getSections()
    const countContainer = document.getElementById('ProductCount')
    const countContainerDesktop = document.getElementById('ProductCountDesktop')
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    )
    loadingSpinners.forEach(spinner => spinner.classList.remove('hidden'))
    document
      .getElementById('ProductGridContainer')
      .querySelector('.collection')
      .classList.add('loading')
    if (countContainer) {
      countContainer.classList.add('loading')
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading')
    }

    sections.forEach(section => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`
      const filterDataUrl = element => element.url === url

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event)
    })

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams)
  }

  static renderSectionFromFetch (url, event) {
    fetch(url)
      .then(response => response.text())
      .then(responseText => {
        const html = responseText
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url }
        ]
        FacetFiltersForm.renderFilters(html, event)
        FacetFiltersForm.renderProductGridContainer(html)
        FacetFiltersForm.renderProductCount(html)
        if (typeof initializeScrollAnimationTrigger === 'function')
          initializeScrollAnimationTrigger(html.innerHTML)
      })
  }

  static renderSectionFromCache (filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html
    FacetFiltersForm.renderFilters(html, event)
    FacetFiltersForm.renderProductGridContainer(html)
    FacetFiltersForm.renderProductCount(html)
    if (typeof initializeScrollAnimationTrigger === 'function')
      initializeScrollAnimationTrigger(html.innerHTML)
  }

  static renderProductGridContainer (html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach(element => {
        element.classList.add('scroll-trigger--cancel')
      })

    const gridView = localStorage.getItem('collection-layout');

    if (gridView === 'list') {
      document.getElementById('ProductGridContainer').querySelector('#product-grid').setAttribute('data-layout', 'list');
    }
  }

  static renderProductCount (html) {
    const countElem = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductCount');
    if (!countElem) return;
    const count = countElem.innerHTML
    const container = document.getElementById('ProductCount')
    const containerDesktop = document.getElementById('ProductCountDesktop')
    container.innerHTML = count
    container.classList.remove('loading')
    if (containerDesktop) {
      containerDesktop.innerHTML = count
      containerDesktop.classList.remove('loading')
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    )
    loadingSpinners.forEach(spinner => spinner.classList.add('hidden'))
  }

  static renderFilters (html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html')
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #StickyFacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter, #vertical-facets-filter-form, #FacetBlockFiltersForm, #FacetBlockFiltersFormMobile, #FilterCollapser'
    )
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #StickyFacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter, #vertical-facets-filter-form, #FacetBlockFiltersForm, #FacetBlockFiltersFormMobile, #FilterCollapser'
    )

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach(currentElement => {
      if (
        !Array.from(facetDetailsElementsFromFetch).some(
          ({ id }) => currentElement.id === id
        )
      ) {
        currentElement.remove()
      }
    })

    const matchesId = element => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined
      return jsFilter ? element.id === jsFilter.id : false
    }

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter(
      element => !matchesId(element)
    )

    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(
      matchesId
    )

    let blockForms = [];
    for (let i = 0; i < facetsToRender.length; i++) {
      if (facetsToRender[i].id === "FacetBlockFiltersForm"
        || facetsToRender[i].id === "FacetBlockFiltersFormMobile"
        || facetsToRender[i].id === "FilterCollapser") {
        blockForms.push(facetsToRender.splice(i, 1)[0]);
        i--;
      }
    }

    if (blockForms.length > 0) {
      for (const blockForm of blockForms) {
        facetsToRender.push(blockForm);
      }
    }

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id)
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML =
          elementToRender.innerHTML
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } =
            facetsToRender[index - 1]
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender)
            return
          }
        }

        if (elementToRender.parentElement) {
          if(document.querySelector(`#${elementToRender.parentElement.id} .filter--labels`)) {
            document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).innerHTML = elementToRender.innerHTML;
          } else {
            document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
          }
        }
      }
    })

    FacetFiltersForm.renderActiveFacets(parsedHTML)
    FacetFiltersForm.renderAdditionalElements(parsedHTML)

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(
          countsToRender,
          event.target.closest('.js-filter')
        )
        FacetFiltersForm.renderMobileCounts(
          countsToRender,
          document.getElementById(closestJSFilterID)
        )

        const newFacetDetailsElement =
          document.getElementById(closestJSFilterID)
        const newElementSelector = newFacetDetailsElement.classList.contains(
          'mobile-facets__details'
        )
          ? `.mobile-facets__close-button`
          : `.facets__summary`
        const newElementToActivate =
          newFacetDetailsElement.querySelector(newElementSelector)

        const isTextInput = event.target.getAttribute('type') === 'text'

        if (newElementToActivate && !isTextInput) newElementToActivate.focus()
      }
    }
  }

  static renderActiveFacets (html) {
    const activeFacetElementSelectors = [
      '.active-facets-mobile',
      '.active-facets-desktop'
    ]

    activeFacetElementSelectors.forEach(selector => {
      const activeFacetsElement = html.querySelector(selector)
      if (!activeFacetsElement) return
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML
    })

    FacetFiltersForm.toggleActiveFacets(false)
  }

  static renderAdditionalElements (html) {
    const mobileElementSelectors = [
      '.mobile-facets__open',
      '.mobile-facets__count',
      '.sticky-mobile-facets__open',
      '.sticky-mobile-facets__count',
      '.sorting',
      '.sticky-sorting'
    ]

    mobileElementSelectors.forEach(selector => {
      if (!html.querySelector(selector)) return
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML
    })

    document
      .getElementById('FacetFiltersFormMobile')
      .closest('menu-drawer')
      .bindEvents()
  }

  static renderCounts (source, target) {
    const targetSummary = target.querySelector('.facets__summary')
    const sourceSummary = source.querySelector('.facets__summary')

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML
    }

    const targetHeaderElement = target.querySelector('.facets__header')
    const sourceHeaderElement = source.querySelector('.facets__header')

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML
    }

    const targetWrapElement = target.querySelector('.facets-wrap')
    const sourceWrapElement = source.querySelector('.facets-wrap')

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(
        target.querySelector('show-more-button .label-show-more.hidden')
      )
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach(hiddenItem =>
            hiddenItem.classList.replace('hidden', 'show-more-item')
          )
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML
    }
  }

  static renderMobileCounts (source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list')
    const sourceFacetsList = source.querySelector('.mobile-facets__list')

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML
    }
  }

  static updateURLHash (searchParams) {
    history.pushState(
      { searchParams },
      '',
      `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`
    )
  }

  static getSections () {
    return [
      {
        section: document.getElementById('product-grid').dataset.id
      }
    ]
  }

  createSearchParams (form) {
    let formData = new FormData(form);
    for (const key of formData.keys()) {
      if (!formData.get(key) || formData.get(key) === '') {
        formData.delete(key)
      }
    }
    if(form.classList.contains("facet-asd")) {
      return new URLSearchParams(formData).toString().replaceAll("%2C", ",")
    } else {
      return new URLSearchParams(formData).toString()
    }
  }

  onSubmitForm (searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler (event) {
    event.preventDefault()
    const sortFilterForms = document.querySelectorAll('facet-filters-form form')
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      if (searchParams === '') {
        return;
      }
      this.onSubmitForm(searchParams, event)
    } else {
      const currentSearchParams = new URL(window.location.href).searchParams;
      const eventForm = event.target.closest('form');
      const formSearcParams = new URLSearchParams(this.createSearchParams(eventForm));

      for (const [key, value] of formSearcParams.entries()) {
        currentSearchParams.set(key, formSearcParams.getAll(key).join(","));
      }

      this.onSubmitForm(currentSearchParams.toString().replaceAll("%2C", ","), event);

      /*const forms = []
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach(form => {
        if (!isMobile) {
          if (
            form.id === 'FacetSortForm' ||
            form.id === 'FacetFiltersForm' ||
            form.id === 'FacetSortDrawerForm' ||
            form.id === 'FacetBlockFiltersForm' ||
            form.id === 'FacetBlockFiltersFormMobile'
          ) {
            const searchParam = this.createSearchParams(form);
            console.log(searchParam);
            if (searchParam !== '') {
              forms.push(this.createSearchParams(form))
            }
          }
        } else if (form.id === 'FacetFiltersFormMobile' || form.id === 'FacetBlockFiltersForm' || form.id === 'FacetBlockFiltersFormMobile') {
          const searchParam = this.createSearchParams(form);
          if (searchParam !== '') {
            forms.push(this.createSearchParams(form))
          }
        }
      })
      this.onSubmitForm(forms.join('&'), event)*/
    }
  }

  onActiveFilterClick (event) {
    event.preventDefault()
    FacetFiltersForm.toggleActiveFacets()

    const searchParams = new URL(event.currentTarget.href).searchParams;
    const newSearchParams = new URLSearchParams();

    for (const [key, value] of searchParams.entries()) {
      newSearchParams.set(key, searchParams.getAll(key).join(","));
    }

    //this.onSubmitForm(currentSearchParams.toString().replaceAll("%2C", ","), event);

    /*const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf('?') + 1
          )*/

    FacetFiltersForm.renderPage(newSearchParams.toString().replaceAll("%2C", ","));
  }
}

FacetFiltersForm.filterData = []
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1)
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1)
customElements.define('facet-filters-form', FacetFiltersForm)
FacetFiltersForm.setListeners()

class FacetRemove extends HTMLElement {
  constructor () {
    super()
    const facetLink = this.querySelector('a')
    facetLink.setAttribute('role', 'button')
    facetLink.addEventListener('click', this.closeFilter.bind(this))
    facetLink.addEventListener('keyup', event => {
      event.preventDefault()
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event)
    })
  }

  closeFilter (event) {
    event.preventDefault()
    const form =
      this.closest('facet-filters-form') ||
      document.querySelector('facet-filters-form')
    form.onActiveFilterClick(event)
  }
}

customElements.define('facet-remove', FacetRemove)

class LayoutChanger extends HTMLElement {
  constructor () {
    super();

    if (!this.section || !this.productGrid) {
      return;
    }

    this.buttons = this.querySelectorAll('button');

    for (const button of this.buttons) {
      button.addEventListener('click', this.changeLayout.bind(this));
    }
  }

  get section() {
    return this.closest('.section') || null;
  }

  get productGrid() {
    return this.section ? this.section.querySelector('.product-grid') : null;
  }

  connectedCallback() {
    const localStorageLayout = window.localStorage.getItem('collection-layout');
    if (localStorageLayout !== null) {
      this.productGrid.setAttribute('data-layout', localStorageLayout);
      const selectedOption = [...this.buttons].filter(button => button.dataset.type === localStorageLayout)[0];
      selectedOption.classList.add('selected', 'button--primary');
      selectedOption.classList.remove('button--tertiary');
    } else {
      this.productGrid.setAttribute('data-layout', 'grid');
      const selectedOption = [...this.buttons].filter(button => button.dataset.type === 'grid')[0];
      selectedOption.classList.add('selected', 'button--primary');
      selectedOption.classList.remove('button--tertiary');
      window.localStorage.setItem('collection-layout', 'grid');
    }
  }

  changeLayout (event) {
    const selectedOption = this.querySelector('.selected');

    if (event.target === selectedOption) {
      return;
    }

    const type = event.target.dataset.type;
    window.localStorage.setItem('collection-layout', type);

    this.productGrid.setAttribute('data-layout', type);

    selectedOption.classList.remove('selected', 'button--primary');
    selectedOption.classList.add('button--tertiary');
    event.target.classList.add('selected', 'button--primary');
    event.target.classList.remove('button--tertiary');

    window.lazySizes.autoSizer.checkElems();
  }
}

customElements.define('layout-changer', LayoutChanger)

/* localization-form.js */
if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor () {
        super()
        this.mql = window.matchMedia('(min-width: 750px)')
        this.header = document.querySelector('.header-wrapper')
        this.elements = {
          input: this.querySelector(
            'input[name="locale_code"], input[name="country_code"]'
          ),
          button: this.querySelector('button.localization-form__select'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          search: this.querySelector('input[name="country_filter"]'),
          closeButton: this.querySelector('.country-selector__close-button'),
          resetButton: this.querySelector('.country-filter__reset-button'),
          searchIcon: this.querySelector('.country-filter__search-icon'),
          liveRegion: this.querySelector('#sr-country-search-results')
        }
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this))
        this.addEventListener('keydown', this.onContainerKeyDown.bind(this))
        this.addEventListener('focusout', this.closeSelector.bind(this))
        this.elements.button.addEventListener(
          'click',
          this.openSelector.bind(this)
        )

        if (this.elements.search) {
          this.elements.search.addEventListener(
            'keyup',
            this.filterCountries.bind(this)
          )
          this.elements.search.addEventListener(
            'focus',
            this.onSearchFocus.bind(this)
          )
          this.elements.search.addEventListener(
            'blur',
            this.onSearchBlur.bind(this)
          )
          this.elements.search.addEventListener(
            'keydown',
            this.onSearchKeyDown.bind(this)
          )
        }
        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener(
            'click',
            this.hidePanel.bind(this)
          )
        }
        if (this.elements.resetButton) {
          this.elements.resetButton.addEventListener(
            'click',
            this.resetFilter.bind(this)
          )
          this.elements.resetButton.addEventListener('mousedown', event =>
            event.preventDefault()
          )
        }

        this.querySelectorAll('a').forEach(item =>
          item.addEventListener('click', this.onItemClick.bind(this))
        )
      }

      hidePanel () {
        this.elements.button.setAttribute('aria-expanded', 'false')
        this.elements.panel.setAttribute('hidden', true)
        if (this.elements.search) {
          this.elements.search.value = ''
          this.filterCountries()
          this.elements.search.setAttribute('aria-activedescendant', '')
        }
        document.body.classList.remove('overflow-hidden-mobile')
        document
          .querySelector('.menu-drawer')
          .classList.remove('country-selector-open')
        this.header.preventHide = false
      }

      onContainerKeyDown (event) {
        const focusableItems = Array.from(this.querySelectorAll('a')).filter(
          item => !item.parentElement.classList.contains('hidden')
        )
        let focusedItemIndex = focusableItems.findIndex(
          item => item === document.activeElement
        )
        let itemToFocus

        switch (event.code.toUpperCase()) {
          case 'ARROWUP':
            event.preventDefault()
            itemToFocus =
              focusedItemIndex > 0
                ? focusableItems[focusedItemIndex - 1]
                : focusableItems[focusableItems.length - 1]
            itemToFocus.focus()
            break
          case 'ARROWDOWN':
            event.preventDefault()
            itemToFocus =
              focusedItemIndex < focusableItems.length - 1
                ? focusableItems[focusedItemIndex + 1]
                : focusableItems[0]
            itemToFocus.focus()
            break
        }

        if (!this.elements.search) return

        setTimeout(() => {
          focusedItemIndex = focusableItems.findIndex(
            item => item === document.activeElement
          )
          if (focusedItemIndex > -1) {
            this.elements.search.setAttribute(
              'aria-activedescendant',
              focusableItems[focusedItemIndex].id
            )
          } else {
            this.elements.search.setAttribute('aria-activedescendant', '')
          }
        })
      }

      onContainerKeyUp (event) {
        event.preventDefault()

        switch (event.code.toUpperCase()) {
          case 'ESCAPE':
            if (this.elements.button.getAttribute('aria-expanded') == 'false')
              return
            this.hidePanel()
            event.stopPropagation()
            this.elements.button.focus()
            break
          case 'SPACE':
            if (this.elements.button.getAttribute('aria-expanded') == 'true')
              return
            this.openSelector()
            break
        }
      }

      onItemClick (event) {
        event.preventDefault()
        const form = this.querySelector('form')
        this.elements.input.value = event.currentTarget.dataset.value
        if (form) form.submit()
      }

      openSelector () {
        this.elements.button.focus()
        this.elements.panel.toggleAttribute('hidden')
        this.elements.button.setAttribute(
          'aria-expanded',
          (
            this.elements.button.getAttribute('aria-expanded') === 'false'
          ).toString()
        )
        if (!document.body.classList.contains('overflow-hidden-tablet')) {
          document.body.classList.add('overflow-hidden-mobile')
        }
        if (this.elements.search && this.mql.matches) {
          this.elements.search.focus()
        }
        if (this.hasAttribute('data-prevent-hide')) {
          this.header.preventHide = true
        }
        document
          .querySelector('.menu-drawer')
          .classList.add('country-selector-open')
      }

      closeSelector (event) {
        if (
          event.target.classList.contains('country-selector__overlay') ||
          !this.contains(event.target) ||
          !this.contains(event.relatedTarget)
        ) {
          this.hidePanel()
        }
      }

      filterCountries () {
        const searchValue = this.elements.search.value.toLowerCase()
        const popularCountries = this.querySelector('.popular-countries')
        const allCountries = this.querySelectorAll('a')
        let visibleCountries = allCountries.length

        this.elements.resetButton.classList.toggle('hidden', !searchValue)

        if (popularCountries) {
          popularCountries.classList.toggle('hidden', searchValue)
        }

        allCountries.forEach(item => {
          const countryName = item
            .querySelector('.country')
            .textContent.toLowerCase()
          if (countryName.indexOf(searchValue) > -1) {
            item.parentElement.classList.remove('hidden')
            visibleCountries++
          } else {
            item.parentElement.classList.add('hidden')
            visibleCountries--
          }
        })

        if (this.elements.liveRegion) {
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.countrySelectorSearchCount.replace(
              '[count]',
              visibleCountries
            )
        }

        this.querySelector('.country-selector').scrollTop = 0
        this.querySelector('.country-selector__list').scrollTop = 0
      }

      resetFilter (event) {
        event.stopPropagation()
        this.elements.search.value = ''
        this.filterCountries()
        this.elements.search.focus()
      }

      onSearchFocus () {
        this.elements.searchIcon.classList.add(
          'country-filter__search-icon--hidden'
        )
      }

      onSearchBlur () {
        if (!this.elements.search.value) {
          this.elements.searchIcon.classList.remove(
            'country-filter__search-icon--hidden'
          )
        }
      }

      onSearchKeyDown (event) {
        if (event.code.toUpperCase() === 'ENTER') {
          event.preventDefault()
        }
      }
    }
  )
}

/* magnify.js */
// create a container and set the full-size image as its background
function createOverlay (image) {
  const overlayImage = document.createElement('img')
  overlayImage.setAttribute('src', `${image.src}`)
  overlay = document.createElement('div')
  prepareOverlay(overlay, overlayImage)

  image.style.opacity = '50%'
  toggleLoadingSpinner(image)

  overlayImage.onload = () => {
    toggleLoadingSpinner(image)
    image.parentElement.insertBefore(overlay, image)
    image.style.opacity = '100%'
  }

  return overlay
}

function prepareOverlay (container, image) {
  container.setAttribute('class', 'image-magnify-full-size')
  container.setAttribute('aria-hidden', 'true')
  container.style.backgroundImage = `url('${image.src}')`
  container.style.backgroundColor = 'var(--gradient-background)'
}

function toggleLoadingSpinner (image) {
  const loadingSpinner =
    image.parentElement.parentElement.querySelector(`.loading__spinner`)
  loadingSpinner.classList.toggle('hidden')
}

function moveWithHover (image, event, zoomRatio) {
  // calculate mouse position
  const ratio = image.height / image.width
  const container = event.target.getBoundingClientRect()
  const xPosition = event.clientX - container.left
  const yPosition = event.clientY - container.top
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`

  // determine what to show in the frame
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`
}

function magnify (image, zoomRatio) {
  const overlay = createOverlay(image)
  overlay.onclick = () => overlay.remove()
  overlay.onmousemove = event => moveWithHover(image, event, zoomRatio)
  overlay.onmouseleave = () => overlay.remove()
}

function enableZoomOnHover (zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover')
  images.forEach(image => {
    image.onclick = event => {
      magnify(image, zoomRatio)
      moveWithHover(image, event, zoomRatio)
    }
  })
}

enableZoomOnHover(2)

/* search-form.js */
class SearchForm extends HTMLElement {
  constructor () {
    super()
    this.input = this.querySelector('input[type="search"]')
    this.resetButton = this.querySelector('button[type="reset"]')

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this))
      this.input.addEventListener(
        'input',
        debounce(event => {
          this.onChange(event)
        }, 300).bind(this)
      )
    }
  }

  toggleResetButton () {
    /*
    const resetIsHidden = this.resetButton.classList.contains('hidden')
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden')
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden')
    }
    */
  }

  onChange () {
    this.toggleResetButton()
  }

  shouldResetForm () {
    return !document.querySelector('[aria-selected="true"] a')
  }

  onFormReset (event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault()
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = ''
      this.input.focus()
      this.toggleResetButton()
    }
  }
}

customElements.define('search-form', SearchForm)

/* main-search.js */
class MainSearch extends SearchForm {
  constructor () {
    super()
    this.allSearchInputs = document.querySelectorAll('input[type="search"]')
    this.setupEventListeners()
  }

  setupEventListeners () {
    let allSearchForms = []
    this.allSearchInputs.forEach(input => allSearchForms.push(input.form))
    this.input.addEventListener('focus', this.onInputFocus.bind(this))
    if (allSearchForms.length < 2) return
    allSearchForms.forEach(form =>
      form.addEventListener('reset', this.onFormReset.bind(this))
    )
    this.allSearchInputs.forEach(input =>
      input.addEventListener('input', this.onInput.bind(this))
    )
  }

  onFormReset (event) {
    super.onFormReset(event)
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input)
    }
  }

  onInput (event) {
    const target = event.target
    this.keepInSync(target.value, target)
  }

  onInputFocus () {
    const isSmallScreen = window.innerWidth < 750
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' })
    }
  }

  keepInSync (value, target) {
    this.allSearchInputs.forEach(input => {
      if (input !== target) {
        input.value = value
      }
    })
  }
}

customElements.define('main-search', MainSearch)

/* media-gallery.js */
if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor () {
        super()
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
        }
        this.mql = window.matchMedia('(min-width: 750px)')
        if (!this.elements.thumbnails) return

        this.elements.viewer.addEventListener(
          'slideChanged',
          debounce(this.onSlideChanged.bind(this), 500)
        )
        this.elements.thumbnails
          .querySelectorAll('[data-target]')
          .forEach(mediaToSwitch => {
            mediaToSwitch
              .querySelector('button')
              .addEventListener(
                'click',
                this.setActiveMedia.bind(this, mediaToSwitch.dataset.target)
              )
          })
        if (
          this.dataset.desktopLayout.includes('thumbnail') &&
          this.mql.matches
        )
          this.removeListSemantic()
      }

      onSlideChanged (event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        )
        this.setActiveThumbnail(thumbnail)
      }

      setActiveMedia (mediaId) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]')
        if (!activeMedia) {
          return
        }
        this.elements.viewer
          .querySelectorAll('[data-media-id]')
          .forEach(element => {
            element.classList.remove('is-active')
          })
        activeMedia?.classList?.add('is-active')

        this.preventStickyHeader()
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft })
          }
          const activeMediaRect = activeMedia.getBoundingClientRect()
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return
          const top = activeMediaRect.top + window.scrollY
          window.scrollTo({ top: top, behavior: 'smooth' })
        })
        this.playActiveMedia(activeMedia)

        if (!this.elements.thumbnails) return
        const activeThumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`
        )
        this.setActiveThumbnail(activeThumbnail)
        this.announceLiveRegion(
          activeMedia,
          activeThumbnail.dataset.mediaPosition
        )
      }

      setActiveThumbnail (thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach(element => element.removeAttribute('aria-current'))
        thumbnail.querySelector('button').setAttribute('aria-current', true)
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft })
      }

      announceLiveRegion (activeItem, position) {
        const image = activeItem.querySelector(
          '.product__modal-opener--image img'
        )
        if (!image) return
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false)
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              '[index]',
              position
            )
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true)
          }, 2000)
        }
        image.src = image.src
      }

      playActiveMedia (activeItem) {
        window.pauseAllMedia()
        const deferredMedia = activeItem.querySelector('.deferred-media')
        if (deferredMedia) deferredMedia.loadContent(false)
      }

      preventStickyHeader () {
        this.stickyHeader =
          this.stickyHeader || document.querySelector('sticky-header')
        if (!this.stickyHeader) return
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'))
      }

      removeListSemantic () {
        if (!this.elements.viewer.slider) return
        this.elements.viewer.slider.setAttribute('role', 'presentation')
        this.elements.viewer.sliderItems.forEach(slide =>
          slide.setAttribute('role', 'presentation')
        )
      }
    }
  )
}

/* password-modal.js */
class PasswordModal extends DetailsModal {
  constructor () {
    super()

    if (this.querySelector('input[aria-invalid="true"]'))
      this.open({ target: this.querySelector('details') })
  }
}

customElements.define('password-modal', PasswordModal)

/* pickup-availability.js */
if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor () {
        super()

        if (!this.hasAttribute('available')) return

        this.errorHtml =
          this.querySelector('template').content.firstElementChild.cloneNode(
            true
          )
        this.onClickRefreshList = this.onClickRefreshList.bind(this)
        this.fetchAvailability(this.dataset.variantId)
      }

      fetchAvailability (variantId) {
        let rootUrl = this.dataset.rootUrl
        if (!rootUrl.endsWith('/')) {
          rootUrl = rootUrl + '/'
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`

        fetch(variantSectionUrl)
          .then(response => response.text())
          .then(text => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section')
            this.renderPreview(sectionInnerHTML)
          })
          .catch(e => {
            const button = this.querySelector('button')
            if (button)
              button.removeEventListener('click', this.onClickRefreshList)
            this.renderError()
          })
      }

      onClickRefreshList (evt) {
        this.fetchAvailability(this.dataset.variantId)
      }

      renderError () {
        this.innerHTML = ''
        this.appendChild(this.errorHtml)

        this.querySelector('button').addEventListener(
          'click',
          this.onClickRefreshList
        )
      }

      renderPreview (sectionInnerHTML) {
        const drawer = document.querySelector('pickup-availability-drawer')
        if (drawer) drawer.remove()
        if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
          this.innerHTML = ''
          this.removeAttribute('available')
          return
        }

        this.innerHTML = sectionInnerHTML.querySelector(
          'pickup-availability-preview'
        ).outerHTML
        this.setAttribute('available', '')

        document.body.appendChild(
          sectionInnerHTML.querySelector('pickup-availability-drawer')
        )
        const colorClassesToApply =
          this.dataset.productPageColorScheme.split(' ')
        colorClassesToApply.forEach(colorClass => {
          document
            .querySelector('pickup-availability-drawer')
            .classList.add(colorClass)
        })

        const button = this.querySelector('button')
        if (button)
          button.addEventListener('click', evt => {
            document
              .querySelector('pickup-availability-drawer')
              .show(evt.target)
          })
      }
    }
  )
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define(
    'pickup-availability-drawer',
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor () {
        super()

        this.onBodyClick = this.handleBodyClick.bind(this)

        this.querySelector('button').addEventListener('click', () => {
          this.hide()
        })

        this.addEventListener('keyup', event => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide()
        })
      }

      handleBodyClick (evt) {
        const target = evt.target
        if (
          target != this &&
          !target.closest('pickup-availability-drawer') &&
          target.id != 'ShowPickupAvailabilityDrawer'
        ) {
          this.hide()
        }
      }

      hide () {
        this.removeAttribute('open')
        document.body.removeEventListener('click', this.onBodyClick)
        document.body.classList.remove('overflow-hidden')
        removeTrapFocus(this.focusElement)
      }

      show (focusElement) {
        this.focusElement = focusElement
        this.setAttribute('open', '')
        document.body.addEventListener('click', this.onBodyClick)
        document.body.classList.add('overflow-hidden')
        trapFocus(this)
      }
    }
  )
}

/* predictive-search.js */
class PredictiveSearch extends SearchForm {
  constructor () {
    super()
    this.cachedResults = {}
    this.predictiveSearchResults = this.querySelector(
      '[data-predictive-search]'
    )
    this.allPredictiveSearchInstances =
      document.querySelectorAll('predictive-search')
    this.isOpen = false
    this.abortController = new AbortController()
    this.searchTerm = ''

    this.setupEventListeners()
  }

  setupEventListeners () {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this))

    this.input.addEventListener('focus', this.onFocus.bind(this))
    this.addEventListener('focusout', this.onFocusOut.bind(this))
    this.addEventListener('keyup', this.onKeyup.bind(this))
    this.addEventListener('keydown', this.onKeydown.bind(this))
  }

  getQuery () {
    return this.input.value.trim()
  }

  onChange () {
    super.onChange()
    const newSearchTerm = this.getQuery()
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      // Remove the results when they are no longer relevant for the new search term
      // so they don't show up when the dropdown opens again
      this.querySelector('#predictive-search-results-groups-wrapper')?.remove()
    }

    // Update the term asap, don't wait for the predictive search query to finish loading
    this.updateSearchForTerm(this.searchTerm, newSearchTerm)

    this.searchTerm = newSearchTerm

    /*
    if (!this.searchTerm.length) {
      this.close(true)
      return
    }
    */

    this.getSearchResults(this.searchTerm)
  }

  onFormSubmit (event) {
    if (
      !this.getQuery().length ||
      this.querySelector('[aria-selected="true"] a')
    )
      event.preventDefault()
  }

  onFormReset (event) {
    super.onFormReset(event)
    if (super.shouldResetForm()) {
      this.searchTerm = ''
      this.abortController.abort()
      this.abortController = new AbortController()
      this.closeResults(true)
    }
  }

  onFocus () {
    const currentSearchTerm = this.getQuery()

    const carousel = this.querySelector('flickity-carousel');
    if (carousel) {
      window.dispatchEvent(new Event('resize'))
    }

    if (!currentSearchTerm.length) return

    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange()
    } else if (this.getAttribute('results') === 'true') {
      this.open()
    } else {
      this.getSearchResults(this.searchTerm)
    }
  }

  onFocusOut () {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close()
    })
  }

  onKeyup (event) {
    if (!this.getQuery().length) this.close(true)
    event.preventDefault()

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up')
        break
      case 'ArrowDown':
        this.switchOption('down')
        break
      case 'Enter':
        this.selectOption()
        break
    }
  }

  onKeydown (event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault()
    }
  }

  updateSearchForTerm (previousTerm, newTerm) {
    const searchForTextElement = this.querySelector(
      '[data-predictive-search-search-for-text]'
    )
    const currentButtonText = searchForTextElement?.innerText
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, 'g')).length > 1) {
        // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
        return
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm)
      searchForTextElement.innerText = newButtonText
    }
  }

  switchOption (direction) {
    if (!this.getAttribute('open')) return

    const moveUp = direction === 'up'
    const selectedElement = this.querySelector('[aria-selected="true"]')

    // Filter out hidden elements (duplicated page and article resources) thanks
    // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
    const allVisibleElements = Array.from(
      this.querySelectorAll('li, button.predictive-search__item')
    ).filter(element => element.offsetParent !== null)
    let activeElementIndex = 0

    if (moveUp && !selectedElement) return

    let selectedElementIndex = -1
    let i = 0

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i
      }
      i++
    }

    this.statusElement.textContent = ''

    if (!moveUp && selectedElement) {
      activeElementIndex =
        selectedElementIndex === allVisibleElements.length - 1
          ? 0
          : selectedElementIndex + 1
    } else if (moveUp) {
      activeElementIndex =
        selectedElementIndex === 0
          ? allVisibleElements.length - 1
          : selectedElementIndex - 1
    }

    if (activeElementIndex === selectedElementIndex) return

    const activeElement = allVisibleElements[activeElementIndex]

    activeElement.setAttribute('aria-selected', true)
    if (selectedElement) selectedElement.setAttribute('aria-selected', false)

    this.input.setAttribute('aria-activedescendant', activeElement.id)
  }

  selectOption () {
    const selectedOption = this.querySelector(
      '[aria-selected="true"] a, button[aria-selected="true"]'
    )

    if (selectedOption) selectedOption.click()
  }

  getSearchResults (searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase()
    this.setLiveRegionLoadingState()

    console.log('fetching');

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey])
      return
    }

    let url = `${routes.predictive_search_url}?q=${encodeURIComponent(
      searchTerm
    )}&section_id=predictive-search`;
    if (searchTerm.trim() === "") {
      url = "/?section_id=predictive-search"
    }

    fetch(url, { signal: this.abortController.signal })
      .then(response => {
        if (!response.ok) {
          var error = new Error(response.status)
          this.close()
          throw error
        }

        return response.text()
      })
      .then(text => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML
        // Save bandwidth keeping the cache in all instances synced
        this.allPredictiveSearchInstances.forEach(predictiveSearchInstance => {
          predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup
        })
        this.renderSearchResults(resultsMarkup)
      })
      .catch(error => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return
        }
        this.close()
        throw error
      })
  }

  setLiveRegionLoadingState () {
    this.statusElement =
      this.statusElement || this.querySelector('.predictive-search-status')
    this.loadingText =
      this.loadingText || this.getAttribute('data-loading-text')

    this.setLiveRegionText(this.loadingText)
    this.setAttribute('loading', true)
  }

  setLiveRegionText (statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false')
    this.statusElement.textContent = statusText

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true')
    }, 1000)
  }

  renderSearchResults (resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup
    this.setAttribute('results', true)

    this.setLiveRegionResults()
    this.open()
  }

  setLiveRegionResults () {
    this.removeAttribute('loading')
    this.setLiveRegionText(
      this.querySelector('[data-predictive-search-live-region-count-value]')
        .textContent
    )
  }

  getResultsMaxHeight () {
    this.resultsMaxHeight =
      window.innerHeight -
      document.querySelector('.section-header').getBoundingClientRect().bottom
    return this.resultsMaxHeight
  }

  open () {
    this.predictiveSearchResults.style.maxHeight =
      this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`
    this.setAttribute('open', true)
    this.input.setAttribute('aria-expanded', true)
    this.isOpen = true
  }

  close (clearSearchTerm = false) {
    this.closeResults(clearSearchTerm)
    this.isOpen = false
  }

  closeResults (clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = ''
      this.removeAttribute('results')
    }
    const selected = this.querySelector('[aria-selected="true"]')

    if (selected) selected.setAttribute('aria-selected', false)

    this.input.setAttribute('aria-activedescendant', '')
    this.removeAttribute('loading')
    this.removeAttribute('open')
    this.input.setAttribute('aria-expanded', false)
    this.resultsMaxHeight = false
    this.predictiveSearchResults.removeAttribute('style')
  }
}

customElements.define('predictive-search', PredictiveSearch)

/* price-per-item.js */
if (!customElements.get('price-per-item')) {
  customElements.define(
    'price-per-item',
    class PricePerItem extends HTMLElement {
      constructor () {
        super()
        this.variantId = this.dataset.variantId
        this.input = document.getElementById(
          `Quantity-${this.dataset.sectionId || this.dataset.variantId}`
        )
        if (this.input) {
          this.input.addEventListener('change', this.onInputChange.bind(this))
        }

        this.getVolumePricingArray()
      }

      variantIdChangedUnsubscriber = undefined

      connectedCallback () {
        // Update variantId if variant is switched on product page
        this.variantIdChangedUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          event => {
            this.variantId = event.data.variant.id.toString()
            this.getVolumePricingArray()
          }
        )
      }

      disconnectedCallback () {
        if (this.variantIdChangedUnsubscriber) {
          this.variantIdChangedUnsubscriber()
        }
      }

      onInputChange () {
        this.updatePricePerItem()
      }

      updatePricePerItem () {
        if (this.input) {
          this.enteredQty = parseInt(this.input.value);
        }

        for (let pair of this.qtyPricePairs) {
          if (this.enteredQty >= pair[0]) {
            const pricePerItemCurrent = document.querySelector(
              `price-per-item[id^="Price-Per-Item-${
                this.dataset.sectionId || this.dataset.variantId
              }"] .price-per-item span`
            )
            this.classList.contains('variant-item__price-per-item')
              ? (pricePerItemCurrent.innerHTML =
                  window.quickOrderListStrings.each.replace('[money]', pair[1]))
              : (pricePerItemCurrent.innerHTML = pair[1])
            break
          }
        }
      }

      getVolumePricingArray () {
        const volumePricing = document.getElementById(
          `Volume-${this.dataset.sectionId || this.dataset.variantId}`
        )
        this.qtyPricePairs = []

        if (volumePricing) {
          volumePricing.querySelectorAll('li').forEach(li => {
            const qty = parseInt(
              li.querySelector('span:first-child, label > span').textContent
            )
            const price = li.querySelector('span:not(:first-child):last-child, label > span:last-child')
              .dataset.text
            this.qtyPricePairs.push([qty, price])
          })
        }
        this.qtyPricePairs.reverse()
      }
    }
  )
}

/* product-form.js */
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor () {
        super()

        this.form = this.querySelector('form')
        this.form.querySelector('[name=id]').disabled = false
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer')
        this.submitButton = this.querySelector('[type="submit"]')

        if (document.querySelector('cart-drawer'))
          this.submitButton.setAttribute('aria-haspopup', 'dialog')

        this.hideErrors = this.dataset.hideErrors === 'true'
      }

      onSubmitHandler (evt) {
        evt.preventDefault()
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return

        this.handleErrorMessage()

        this.submitButton.setAttribute('aria-disabled', true)
        this.submitButton.classList.add('loading')
        this.querySelector('.loading__spinner').classList.remove('hidden')

        const config = fetchConfig('javascript')
        config.headers['X-Requested-With'] = 'XMLHttpRequest'
        delete config.headers['Content-Type']

        const formData = new FormData(this.form)
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map(section => section.id)
          )
          formData.append('sections_url', window.location.pathname)
          this.cart.setActiveElement(document.activeElement)
        }
        config.body = formData

        fetch(`${routes.cart_add_url}`, config)
          .then(response => response.json())
          .then(response => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message
              })
              this.handleErrorMessage(response.description)

              const soldOutMessage =
                this.submitButton.querySelector('.sold-out-message')
              if (!soldOutMessage) return
              this.submitButton.setAttribute('aria-disabled', true)
              this.submitButton.querySelector('span').classList.add('hidden')
              soldOutMessage.classList.remove('hidden')
              this.error = true
              return
            } else if (!this.cart) {
              window.location = window.routes.cart_url
              return
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response
              })
            this.error = false
            const quickAddModal = this.closest('quick-add-modal')
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response)
                  })
                },
                { once: true }
              )
              quickAddModal.hide(true)
            } else {
              this.cart.renderContents(response)
            }
          })
          .catch(e => {
            console.error(e)
          })
          .finally(() => {
            this.submitButton.classList.remove('loading')
            if (this.cart && this.cart.classList.contains('is-empty'))
              this.cart.classList.remove('is-empty')
            if (!this.error) this.submitButton.removeAttribute('aria-disabled')
            this.querySelector('.loading__spinner').classList.add('hidden')
          })
      }

      handleErrorMessage (errorMessage = false) {
        if (this.hideErrors) return

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper')
        if (!this.errorMessageWrapper) return
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector('.product-form__error-message')

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage)

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage
        }
      }
    }
  )
}

/* product-info.js */
if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor () {
        super()
        this.input = this.querySelector('.quantity__input')
        this.currentVariant = this.querySelector('.product-variant-id')
        this.submitButton = this.querySelector('[type="submit"]')
      }

      cartUpdateUnsubscriber = undefined
      variantChangeUnsubscriber = undefined

      connectedCallback () {
        if (!this.input) return
        this.quantityForm = this.querySelector('.product-form__quantity')
        if (!this.quantityForm) return
        this.setQuantityBoundries()
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          )
        }
        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          event => {
            const sectionId = this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
            if (event.data.sectionId !== sectionId) return
            this.updateQuantityRules(event.data.sectionId, event.data.html)
            this.setQuantityBoundries()
          }
        )
      }

      disconnectedCallback () {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber()
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber()
        }
      }

      setQuantityBoundries () {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity
            ? parseInt(this.input.dataset.cartQuantity)
            : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1
        }

        let min = data.min
        const max = data.max === null ? data.max : data.max - data.cartQuantity
        if (max !== null) min = Math.min(min, max)
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step)
        this.input.min = min

        if (max) {
          this.input.max = max
        } else {
          this.input.removeAttribute('max')
        }
        this.input.value = min
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined)
      }

      fetchQuantityRules () {
        if (!this.currentVariant || !this.currentVariant.value) return
        /*this.querySelector(
          '.quantity__rules-cart .loading__spinner'
        ).classList.remove('hidden')*/
        fetch(
          `${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`
        )
          .then(response => {
            return response.text()
          })
          .then(responseText => {
            const html = new DOMParser().parseFromString(
              responseText,
              'text/html'
            )
            this.updateQuantityRules(this.dataset.section, html)
            this.setQuantityBoundries()
          })
          .catch(e => {
            console.error(e)
          })
          .finally(() => {
            /*this.querySelector(
              '.quantity__rules-cart .loading__spinner'
            ).classList.add('hidden')*/
          })
      }

      updateQuantityRules (sectionId, html) {
        const quantityFormUpdated = html.getElementById(
          `Quantity-Form-${sectionId}`
        )
        const selectors = [
          '.quantity__input',
          '.quantity__rules',
          '.quantity__label'
        ]
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector)
          const updated = quantityFormUpdated.querySelector(selector)
          if (!current || !updated) continue
          if (selector === '.quantity__input') {
            const attributes = [
              'data-cart-quantity',
              'data-min',
              'data-max',
              'step'
            ]
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute)
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated)
              } else {
                current.removeAttribute(attribute)
              }
            }
          } else {
            current.innerHTML = updated.innerHTML
          }
        }
      }
    }
  )
}

/* product-modal.js */
if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor () {
        super()
      }

      hide () {
        super.hide()
      }

      show (opener) {
        super.show(opener)
        this.showActiveMedia()
      }

      showActiveMedia () {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute(
            'data-media-id'
          )}"])`
        ).forEach(element => {
          element.classList.remove('active')
        })
        const activeMedia = this.querySelector(
          `[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`
        )
        const activeMediaTemplate = activeMedia.querySelector('template')
        const activeMediaContent = activeMediaTemplate
          ? activeMediaTemplate.content
          : null
        activeMedia.classList.add('active')
        activeMedia.scrollIntoView()

        const container = this.querySelector('[role="document"]')
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent()
      }
    }
  )
}

/* product-model.js */
if (!customElements.get('product-model')) {
  customElements.define(
    'product-model',
    class ProductModel extends DeferredMedia {
      constructor () {
        super()
      }

      loadContent () {
        super.loadContent()

        Shopify.loadFeatures([
          {
            name: 'model-viewer-ui',
            version: '1.0',
            onLoad: this.setupModelViewerUI.bind(this)
          }
        ])
      }

      setupModelViewerUI (errors) {
        if (errors) return

        this.modelViewerUI = new Shopify.ModelViewerUI(
          this.querySelector('model-viewer')
        )
      }
    }
  )
}

window.ProductModel = {
  loadShopifyXR () {
    Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXR.bind(this)
      }
    ])
  },

  setupShopifyXR (errors) {
    if (errors) return

    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', () =>
        this.setupShopifyXR()
      )
      return
    }

    document.querySelectorAll('[id^="ProductJSON-"]').forEach(modelJSON => {
      window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent))
      modelJSON.remove()
    })
    window.ShopifyXR.setupXRElements()
  }
}

window.addEventListener('DOMContentLoaded', () => {
  if (window.ProductModel) window.ProductModel.loadShopifyXR()
})

/* quantity-popover.js */
if (!customElements.get('quantity-popover')) {
  customElements.define(
    'quantity-popover',
    class QuantityPopover extends HTMLElement {
      constructor () {
        super()
        this.mql = window.matchMedia('(min-width: 990px)')
        this.mqlTablet = window.matchMedia('(min-width: 750px)')
        this.infoButtonDesktop = this.querySelector(
          '.quantity-popover__info-button--icon-only, .quantity-popover__info-button--icon-with-label'
        )
        this.infoButtonMobile = this.querySelector(
          '.quantity-popover__info-button--icon-with-label'
        )
        this.popoverInfo = this.querySelector('.quantity-popover__info')
        this.closeButton = this.querySelector('.button-close')
        this.eventMouseEnterHappened = false

        if (this.closeButton) {
          this.closeButton.addEventListener(
            'click',
            this.closePopover.bind(this)
          )
        }

        if (
          this.popoverInfo &&
          this.infoButtonDesktop &&
          this.mqlTablet.matches
        ) {
          this.popoverInfo.addEventListener(
            'mouseleave',
            this.closePopover.bind(this)
          )
        }

        if (this.infoButtonDesktop) {
          this.infoButtonDesktop.addEventListener(
            'click',
            this.togglePopover.bind(this)
          )
          this.infoButtonDesktop.addEventListener(
            'focusout',
            this.closePopover.bind(this)
          )
        }

        if (this.infoButtonMobile) {
          this.infoButtonMobile.addEventListener(
            'click',
            this.togglePopover.bind(this)
          )
        }

        if (this.infoButtonDesktop && this.mqlTablet.matches) {
          this.infoButtonDesktop.addEventListener(
            'mouseenter',
            this.togglePopover.bind(this)
          )
          this.infoButtonDesktop.addEventListener(
            'mouseleave',
            this.closePopover.bind(this)
          )
        }
      }

      togglePopover (event) {
        event.preventDefault()
        if (event.type === 'mouseenter') {
          this.eventMouseEnterHappened = true
        }

        if (event.type === 'click' && this.eventMouseEnterHappened) return

        const button =
          this.infoButtonDesktop && this.mql.matches
            ? this.infoButtonDesktop
            : this.infoButtonMobile
        const isExpanded = button.getAttribute('aria-expanded') === 'true'

        if ((this.mql.matches && !isExpanded) || event.type === 'click') {
          button.setAttribute('aria-expanded', !isExpanded)

          this.popoverInfo.toggleAttribute('hidden')

          button.classList.toggle('quantity-popover__info-button--open')

          this.infoButtonDesktop.classList.add(
            'quantity-popover__info-button--icon-only--animation'
          )
        }

        const isOpen = button.getAttribute('aria-expanded') === 'true'

        if (isOpen && event.type !== 'mouseenter') {
          button.focus()
          button.addEventListener('keyup', e => {
            if (e.key === 'Escape') {
              this.closePopover(e)
            }
          })
        }
      }

      closePopover (event) {
        event.preventDefault()
        const isButtonChild = this.infoButtonDesktop.contains(
          event.relatedTarget
        )
        const isPopoverChild = this.popoverInfo.contains(event.relatedTarget)

        const button =
          this.infoButtonDesktop && this.mql.matches
            ? this.infoButtonDesktop
            : this.infoButtonMobile

        if (!isButtonChild && !isPopoverChild) {
          button.setAttribute('aria-expanded', 'false')
          button.classList.remove('quantity-popover__info-button--open')
          this.popoverInfo.setAttribute('hidden', '')
          this.infoButtonDesktop.classList.remove(
            'quantity-popover__info-button--icon-only--animation'
          )
        }

        this.eventMouseEnterHappened = false
      }
    }
  )
}

/* quick-add-bulk.js */
if (!customElements.get('quick-add-bulk')) {
  customElements.define(
    'quick-add-bulk',
    class QuickAddBulk extends HTMLElement {
      constructor () {
        super()
        this.quantity = this.querySelector('quantity-input')
        this.cart = document.querySelector('cart-drawer')
        this.addToCartButton = this.getAddToCartButton() || null

        const debouncedOnChange = debounce(event => {
          if (this.getAddToCartButton()) {
            this.getAddToCartButton().removeEventListener('click', this.handleAddToCart)
          }

          if (parseInt(event.target.dataset.cartQuantity) === 0) {
            this.addToCart(event)
          } else {
            this.updateCart(event)
          }
        }, ON_CHANGE_DEBOUNCE_TIMER)

        if (this.addToCartButton) {
          this.addEventListener('add-to-cart', debouncedOnChange.bind(this))
        }

        if (!this.addToCartButton) {
          this.addEventListener('change', debouncedOnChange.bind(this))
        }

        this.listenForActiveInput()
        this.listenForKeydown()
        this.lastActiveInputId = null
        const pageParams = new URLSearchParams(window.location.search)
        window.pageNumber = decodeURIComponent(pageParams.get('page') || '')
      }

      connectedCallback () {
        this.cartUpdateUnsubscriber = subscribe(
          PUB_SUB_EVENTS.cartUpdate,
          event => {
            if (event.source === 'quick-add') {
              return
            }
            // If its another section that made the update
            this.onCartUpdate().then(() => {
              this.listenForActiveInput()
              this.listenForKeydown()
            })
          }
        )

        this.addHandleAddToCartListener();
      }

      addHandleAddToCartListener () {
        if (this.getAddToCartButton()) {
          this.getAddToCartButton().addEventListener('click', this.handleAddToCart.bind(this));
        }
      }

      handleAddToCart () {
        const changeEvent = new CustomEvent('add-to-cart', {
          bubbles: true
        });

        this.querySelector('input[type="number"]').dispatchEvent(changeEvent);
      }

      disconnectedCallback () {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber()
        }
      }

      getInput () {
        return this.querySelector('quantity-input input')
      }

      getAddToCartButton () {
        return this.querySelector('button[type="submit"]')
      }

      selectProgressBar () {
        return this.querySelector('.progress-bar-container')
      }

      listenForActiveInput () {
        if (!this.classList.contains('hidden')) {
          this.getInput().addEventListener('focusin', event =>
            event.target.select()
          )
        }
        this.isEnterPressed = false
      }

      listenForKeydown () {
        this.getInput().addEventListener('keydown', event => {
          if (event.key === 'Enter') {
            this.getInput().blur()
            this.isEnterPressed = true
          }
        })
      }

      resetQuantityInput (id) {
        const input = document.getElementById(id)
        input.value = input.getAttribute('value')
        this.isEnterPressed = false
      }

      cleanErrorMessageOnType (event) {
        event.target.addEventListener(
          'keypress',
          () => {
            event.target.setCustomValidity('')
          },
          { once: true }
        )
      }

      onCartUpdate () {
        return new Promise((resolve, reject) => {
          fetch(
            `${this.getSectionsUrl()}?section_id=${
              this.closest('.collection').dataset.id
            }`
          )
            .then(response => response.text())
            .then(responseText => {
              const html = new DOMParser().parseFromString(
                responseText,
                'text/html'
              )
              const sourceQty = html.querySelector(
                `#quick-add-bulk-${this.dataset.id}-${
                  this.closest('.collection').dataset.id
                }`
              )
              if (sourceQty) {
                this.innerHTML = sourceQty.innerHTML

                this.addHandleAddToCartListener();
              }
              resolve()
            })
            .catch(e => {
              console.error(e)
              reject(e)
            })
        })
      }

      updateCart (event) {
        this.lastActiveInputId = event.target.getAttribute('data-index')
        this.quantity.classList.add('quantity__input-disabled')
        this.selectProgressBar().classList.remove('hidden')
        const body = JSON.stringify({
          quantity: event.target.value,
          id: event.target.getAttribute('data-index'),
          sections: this.getSectionsToRender().map(section => section.section),
          sections_url: this.getSectionsUrl()
        })

        fetch(`${routes.cart_change_url}`, {
          ...fetchConfig('javascript'),
          ...{ body }
        })
          .then(response => {
            return response.text()
          })
          .then(state => {
            const parsedState = JSON.parse(state)
            this.quantity.classList.remove('quantity__input-disabled')
            if (parsedState.description || parsedState.errors) {
              event.target.setCustomValidity(parsedState.description)
              event.target.reportValidity()
              this.resetQuantityInput(event.target.id)
              this.selectProgressBar().classList.add('hidden')
              event.target.select()
              this.cleanErrorMessageOnType(event)
              return
            }

            this.renderSections(parsedState)

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'quick-add',
              cartData: parsedState
            })
          })
          .catch(error => {
            console.log(error, 'error')
          })
      }

      addToCart (event) {
        this.quantity.classList.add('quantity__input-disabled')
        this.selectProgressBar().classList.remove('hidden')
        this.lastActiveInputId = event.target.getAttribute('data-index')
        const body = JSON.stringify({
          items: [
            {
              quantity: parseInt(event.target.value),
              id: parseInt(this.dataset.id)
            }
          ],
          sections: this.getSectionsToRender().map(section => section.section)
        })

        fetch(`${routes.cart_add_url}`, {
          ...fetchConfig('javascript'),
          ...{ body }
        })
          .then(response => {
            return response.text()
          })
          .then(state => {
            const parsedState = JSON.parse(state)
            this.quantity.classList.remove('quantity__input-disabled')
            if (parsedState.description || parsedState.errors) {
              event.target.setCustomValidity(parsedState.description)
              event.target.reportValidity()
              this.resetQuantityInput(event.target.id)
              this.selectProgressBar().classList.add('hidden')
              event.target.select()
              this.cleanErrorMessageOnType(event)
              // Error handling
              return
            }

            this.renderSections(parsedState)

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'quick-add',
              cartData: parsedState
            })
          })
          .catch(error => {
            console.error(error)
          })
      }

      getSectionsToRender () {
        return [
          {
            id: `quick-add-bulk-${this.dataset.id}-${
              this.closest('.collection-quick-add-bulk').dataset.id
            }`,
            section: this.closest('.collection-quick-add-bulk').dataset.id,
            selector: `#quick-add-bulk-${this.dataset.id}-${
              this.closest('.collection-quick-add-bulk').dataset.id
            }`
          },
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section'
          },
          {
            id: 'CartDrawer',
            selector: '#CartDrawer',
            section: 'cart-drawer'
          }
        ]
      }

      getSectionsUrl () {
        if (window.pageNumber) {
          return `${window.location.pathname}?page=${window.pageNumber}`
        } else {
          return `${window.location.pathname}`
        }
      }

      getSectionInnerHTML (html, selector) {
        return new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector(selector).innerHTML
      }

      renderSections (parsedState) {
        this.getSectionsToRender().forEach(section => {
          const sectionElement = document.getElementById(section.id)
          if (
            sectionElement &&
            sectionElement.parentElement &&
            sectionElement.parentElement.classList.contains('drawer')
          ) {
            parsedState.items.length > 0
              ? sectionElement.parentElement.classList.remove('is-empty')
              : sectionElement.parentElement.classList.add('is-empty')

            setTimeout(() => {
              document
                .querySelector('#CartDrawer-Overlay')
                .addEventListener('click', this.cart.close.bind(this.cart))
            })
          }
          const elementToReplace =
            sectionElement && sectionElement.querySelector(section.selector)
              ? sectionElement.querySelector(section.selector)
              : sectionElement
          if (elementToReplace) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            )

            if (section.id.includes('quick-add-bulk')) {
              this.addHandleAddToCartListener();
            }
          }
        })

        if (this.isEnterPressed) {
          this.querySelector(`#Quantity-${this.lastActiveInputId}`).select()
        }

        this.listenForActiveInput()
        this.listenForKeydown()
      }
    }
  )
}

/* quick-add.js */
if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor () {
        super()
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]')
      }

      hide (preventFocus = false) {
        const cartNotification =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer')
        if (cartNotification) cartNotification.setActiveElement(this.openedBy)
        this.modalContent.innerHTML = ''

        if (preventFocus) this.openedBy = null
        super.hide()
      }

      show (opener) {
        opener.setAttribute('aria-disabled', true)
        opener.classList.add('loading')
        opener.querySelector('.loading__spinner').classList.remove('hidden')

        if(this.dataset.custom == "true") {
          fetch(opener.getAttribute('data-product-url') + "?view=quick-buy-modal")
          .then(response => response.text())
          .then(responseText => {
            const responseHTML = new DOMParser().parseFromString(
              responseText,
              'text/html'
            )
            this.productElement = responseHTML.querySelector(
              'section[id^="MainProduct-"]'
            )
            this.productElement.classList.forEach(classApplied => {
              if (
                classApplied.startsWith('color-') ||
                classApplied === 'gradient'
              )
                this.modalContent.classList.add(classApplied)
            })
            this.preventDuplicatedIDs()
            this.removeDOMElements()
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML)

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init()
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR()

            this.removeGalleryListSemantic()
            this.updateImageSizes()
            this.preventVariantURLSwitching()
            super.show(opener)
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled')
            opener.classList.remove('loading')
            opener.querySelector('.loading__spinner').classList.add('hidden')
          })
        } else {
          fetch(opener.getAttribute('data-product-url'))
          .then(response => response.text())
          .then(responseText => {
            const responseHTML = new DOMParser().parseFromString(
              responseText,
              'text/html'
            )
            this.productElement = responseHTML.querySelector(
              'section[id^="MainProduct-"]'
            )
            this.productElement.classList.forEach(classApplied => {
              if (
                classApplied.startsWith('color-') ||
                classApplied === 'gradient'
              )
                this.modalContent.classList.add(classApplied)
            })
            this.preventDuplicatedIDs()
            this.removeDOMElements()
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML)

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init()
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR()

            this.removeGalleryListSemantic()
            this.updateImageSizes()
            this.preventVariantURLSwitching()
            super.show(opener)
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled')
            opener.classList.remove('loading')
            opener.querySelector('.loading__spinner').classList.add('hidden')
          })
        }
      }

      setInnerHTML (element, html) {
        element.innerHTML = html

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll('script').forEach(oldScriptTag => {
          const newScriptTag = document.createElement('script')
          Array.from(oldScriptTag.attributes).forEach(attribute => {
            newScriptTag.setAttribute(attribute.name, attribute.value)
          })
          newScriptTag.appendChild(
            document.createTextNode(oldScriptTag.innerHTML)
          )
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag)
        })
      }

      preventVariantURLSwitching () {
        const variantPicker = this.modalContent.querySelector('variant-selects')
        if (!variantPicker) return

        variantPicker.setAttribute('data-update-url', 'false')
      }

      removeDOMElements () {
        const pickupAvailability = this.productElement.querySelector(
          'pickup-availability'
        )
        if (pickupAvailability) pickupAvailability.remove()

        const productModal = this.productElement.querySelector('product-modal')
        if (productModal) productModal.remove()

        const modalDialog = this.productElement.querySelectorAll('modal-dialog')
        if (modalDialog) modalDialog.forEach(modal => modal.remove())
      }

      preventDuplicatedIDs () {
        const sectionId = this.productElement.dataset.section
        this.productElement.innerHTML =
          this.productElement.innerHTML.replaceAll(
            sectionId,
            `quickadd-${sectionId}`
          )
        this.productElement
          .querySelectorAll('variant-selects, product-info')
          .forEach(element => {
            element.dataset.originalSection = sectionId
          })
      }

      removeGalleryListSemantic () {
        const galleryList = this.modalContent.querySelector(
          '[id^="Slider-Gallery"]'
        )
        if (!galleryList) return

        galleryList.setAttribute('role', 'presentation')
        galleryList
          .querySelectorAll('[id^="Slide-"]')
          .forEach(li => li.setAttribute('role', 'presentation'))
      }

      updateImageSizes () {
        const product = this.modalContent.querySelector('.product')
        const desktopColumns = product.classList.contains('product--columns')
        if (!desktopColumns) return

        const mediaImages = product.querySelectorAll('.product__media img')
        if (!mediaImages.length) return

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)'

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px')
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px')
        }

        mediaImages.forEach(img => img.setAttribute('sizes', mediaImageSizes))
      }
    }
  )
}

/* quick-order-list.js */
if (!customElements.get('quick-order-list-remove-button')) {
  customElements.define(
    'quick-order-list-remove-button',
    class QuickOrderListRemoveButton extends HTMLElement {
      constructor () {
        super()
        this.addEventListener('click', event => {
          event.preventDefault()
          const quickOrderList = this.closest('quick-order-list')
          quickOrderList.updateQuantity(this.dataset.index, 0)
        })
      }
    }
  )
}

if (!customElements.get('quick-order-list-remove-all-button')) {
  customElements.define(
    'quick-order-list-remove-all-button',
    class QuickOrderListRemoveAllButton extends HTMLElement {
      constructor () {
        super()
        this.quickOrderList = this.closest('quick-order-list')
        const allVariants = this.quickOrderList.querySelectorAll(
          '[data-quantity-variant-id]'
        )
        const items = {}
        let hasVariantsInCart = false

        allVariants.forEach(variant => {
          const cartQty = parseInt(variant.dataset.cartQuantity)
          if (cartQty > 0) {
            hasVariantsInCart = true
            items[parseInt(variant.dataset.quantityVariantId)] = 0
          }
        })

        if (!hasVariantsInCart) {
          this.classList.add('hidden')
        }

        this.actions = {
          confirm: 'confirm',
          remove: 'remove',
          cancel: 'cancel'
        }

        this.addEventListener('click', event => {
          event.preventDefault()
          if (this.dataset.action === this.actions.confirm) {
            this.toggleConfirmation(false, true)
          } else if (this.dataset.action === this.actions.remove) {
            this.quickOrderList.updateMultipleQty(items)
            this.toggleConfirmation(true, false)
          } else if (this.dataset.action === this.actions.cancel) {
            this.toggleConfirmation(true, false)
          }
        })
      }

      toggleConfirmation (showConfirmation, showInfo) {
        this.quickOrderList
          .querySelector('.quick-order-list-total__confirmation')
          .classList.toggle('hidden', showConfirmation)
        this.quickOrderList
          .querySelector('.quick-order-list-total__info')
          .classList.toggle('hidden', showInfo)
      }
    }
  )
}

if (!customElements.get('quick-order-list')) {
  customElements.define(
    'quick-order-list',
    class QuickOrderList extends HTMLElement {
      constructor () {
        super()
        this.cart = document.querySelector('cart-drawer')
        this.actions = {
          add: 'ADD',
          update: 'UPDATE'
        }

        this.quickOrderListId = `quick-order-list-${this.dataset.productId}`
        this.defineInputsAndQuickOrderTable()

        this.variantItemStatusElement = document.getElementById(
          'shopping-cart-variant-item-status'
        )
        const form = this.querySelector('form')
        this.inputFieldHeight = this.querySelector(
          '.variant-item__quantity-wrapper'
        ).offsetHeight
        this.isListInsideModal = document.querySelector('.quick-add-bulk')
        this.stickyHeaderElement = document.querySelector('sticky-header')
        this.getTableHead()
        this.getTotalBar()

        if (this.stickyHeaderElement) {
          this.stickyHeader = {
            height: this.stickyHeaderElement.offsetHeight,
            type: `${this.stickyHeaderElement.getAttribute('data-sticky-type')}`
          }
        }

        if (this.getTotalBar()) {
          this.totalBarPosition =
            window.innerHeight - this.getTotalBar().offsetHeight

          window.addEventListener('resize', () => {
            this.totalBarPosition =
              window.innerHeight - this.getTotalBar().offsetHeight
            this.stickyHeader.height = this.stickyHeaderElement
              ? this.stickyHeaderElement.offsetHeight
              : 0
          })
        }

        const pageParams = new URLSearchParams(window.location.search)
        window.pageNumber = decodeURIComponent(pageParams.get('page') || '')
        form.addEventListener('submit', this.onSubmit.bind(this))
        this.addMultipleDebounce()
      }

      cartUpdateUnsubscriber = undefined

      onSubmit (event) {
        event.preventDefault()
      }

      connectedCallback () {
        this.cartUpdateUnsubscriber = subscribe(
          PUB_SUB_EVENTS.cartUpdate,
          event => {
            if (event.source === this.quickOrderListId) {
              return
            }
            // If its another section that made the update
            this.refresh().then(() => {
              this.defineInputsAndQuickOrderTable()
              this.addMultipleDebounce()
            })
          }
        )
        this.sectionId = this.dataset.id
      }

      disconnectedCallback () {
        this.cartUpdateUnsubscriber?.()
      }

      defineInputsAndQuickOrderTable () {
        this.allInputsArray = Array.from(
          this.querySelectorAll('input[type="number"]')
        )
        this.quickOrderListTable = this.querySelector(
          '.quick-order-list__table'
        )
        this.quickOrderListTable.addEventListener(
          'focusin',
          this.switchVariants.bind(this)
        )
      }

      onChange (event) {
        const inputValue = parseInt(event.target.value)
        const cartQuantity = parseInt(event.target.dataset.cartQuantity)
        const index = event.target.dataset.index
        const name = document.activeElement.getAttribute('name')

        const quantity = inputValue - cartQuantity
        this.cleanErrorMessageOnType(event)
        if (inputValue == 0) {
          this.updateQuantity(index, inputValue, name, this.actions.update)
        } else {
          this.validateQuantity(
            event,
            name,
            index,
            inputValue,
            cartQuantity,
            quantity
          )
        }
      }

      cleanErrorMessageOnType (event) {
        event.target.addEventListener('keydown', () => {
          event.target.setCustomValidity(' ')
          event.target.reportValidity()
        })
      }

      validateQuantity (event, name, index, inputValue, cartQuantity, quantity) {
        if (inputValue < event.target.dataset.min) {
          this.setValidity(
            event,
            index,
            window.quickOrderListStrings.min_error.replace(
              '[min]',
              event.target.dataset.min
            )
          )
        } else if (inputValue > parseInt(event.target.max)) {
          this.setValidity(
            event,
            index,
            window.quickOrderListStrings.max_error.replace(
              '[max]',
              event.target.max
            )
          )
        } else if (inputValue % parseInt(event.target.step) != 0) {
          this.setValidity(
            event,
            index,
            window.quickOrderListStrings.step_error.replace(
              '[step]',
              event.target.step
            )
          )
        } else {
          event.target.setCustomValidity('')
          event.target.reportValidity()
          if (cartQuantity > 0) {
            this.updateQuantity(index, inputValue, name, this.actions.update)
          } else {
            this.updateQuantity(index, quantity, name, this.actions.add)
          }
        }
      }

      setValidity (event, index, message) {
        event.target.setCustomValidity(message)
        event.target.reportValidity()
        this.resetQuantityInput(index)
        event.target.select()
      }

      validateInput (target) {
        if (target.max) {
          return (
            parseInt(target.value) == 0 ||
            (parseInt(target.value) >= parseInt(target.dataset.min) &&
              parseInt(target.value) <= parseInt(target.max) &&
              parseInt(target.value) % parseInt(target.step) == 0)
          )
        } else {
          return (
            parseInt(target.value) == 0 ||
            (parseInt(target.value) >= parseInt(target.dataset.min) &&
              parseInt(target.value) % parseInt(target.step) == 0)
          )
        }
      }

      refresh () {
        return new Promise((resolve, reject) => {
          fetch(`${this.getSectionsUrl()}?section_id=${this.sectionId}`)
            .then(response => response.text())
            .then(responseText => {
              const html = new DOMParser().parseFromString(
                responseText,
                'text/html'
              )
              const sourceQty = html.querySelector(`#${this.quickOrderListId}`)
              if (sourceQty) {
                this.innerHTML = sourceQty.innerHTML
              }
              resolve()
            })
            .catch(e => {
              console.error(e)
              reject(e)
            })
        })
      }

      getSectionsToRender () {
        return [
          {
            id: this.quickOrderListId,
            section: document.getElementById(this.quickOrderListId).dataset.id,
            selector: `#${this.quickOrderListId} .js-contents`
          },
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section'
          },
          {
            id: `quick-order-list-live-region-text-${this.dataset.productId}`,
            section: 'cart-live-region-text',
            selector: '.shopify-section'
          },
          {
            id: `quick-order-list-total-${this.dataset.productId}`,
            section: document.getElementById(this.quickOrderListId).dataset.id,
            selector: `#${this.quickOrderListId} .quick-order-list__total`
          },
          {
            id: 'CartDrawer',
            selector: '#CartDrawer',
            section: 'cart-drawer'
          }
        ]
      }

      addMultipleDebounce () {
        this.querySelectorAll('quantity-input').forEach(qty => {
          const debouncedOnChange = debounce(event => {
            this.onChange(event)
          }, ON_CHANGE_DEBOUNCE_TIMER)
          qty.addEventListener('change', debouncedOnChange.bind(this))
        })
      }

      addDebounce (id) {
        const element = this.querySelector(`#Variant-${id} quantity-input`)
        const debouncedOnChange = debounce(event => {
          this.onChange(event)
        }, ON_CHANGE_DEBOUNCE_TIMER)
        element.addEventListener('change', debouncedOnChange.bind(this))
      }

      renderSections (parsedState, id) {
        this.getSectionsToRender().forEach(section => {
          const sectionElement = document.getElementById(section.id)
          if (
            sectionElement &&
            sectionElement.parentElement &&
            sectionElement.parentElement.classList.contains('drawer')
          ) {
            parsedState.items.length > 0
              ? sectionElement.parentElement.classList.remove('is-empty')
              : sectionElement.parentElement.classList.add('is-empty')
            setTimeout(() => {
              document
                .querySelector('#CartDrawer-Overlay')
                .addEventListener('click', this.cart.close.bind(this.cart))
            })
          }
          const elementToReplace =
            sectionElement && sectionElement.querySelector(section.selector)
              ? sectionElement.querySelector(section.selector)
              : sectionElement
          if (elementToReplace) {
            if (
              section.selector === `#${this.quickOrderListId} .js-contents` &&
              id !== undefined
            ) {
              elementToReplace.querySelector(`#Variant-${id}`).innerHTML =
                this.getSectionInnerHTML(
                  parsedState.sections[section.section],
                  `#Variant-${id}`
                )
            } else {
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              )
            }
          }
        })
        this.defineInputsAndQuickOrderTable()
        if (id) {
          this.addDebounce(id)
        } else {
          this.addMultipleDebounce()
        }
      }

      getTableHead () {
        return document.querySelector('.quick-order-list__table thead')
      }

      getTotalBar () {
        return this.querySelector('.quick-order-list__total')
      }

      scrollQuickOrderListTable () {
        const inputTopBorder = this.variantListInput.getBoundingClientRect().top
        const inputBottomBorder =
          this.variantListInput.getBoundingClientRect().bottom

        if (this.isListInsideModal) {
          const totalBarCrossesInput =
            inputBottomBorder > this.getTotalBar().getBoundingClientRect().top
          const tableHeadCrossesInput =
            inputTopBorder < this.getTableHead().getBoundingClientRect().bottom

          if (totalBarCrossesInput || tableHeadCrossesInput) {
            this.scrollToCenter()
          }
        } else {
          const stickyHeaderBottomBorder =
            this.stickyHeaderElement &&
            this.stickyHeaderElement.getBoundingClientRect().bottom
          const totalBarCrossesInput = inputBottomBorder > this.totalBarPosition
          const inputOutsideOfViewPort =
            inputBottomBorder < this.inputFieldHeight
          const stickyHeaderCrossesInput =
            this.stickyHeaderElement &&
            this.stickyHeader.type !== 'on-scroll-up' &&
            this.stickyHeader.height > inputTopBorder
          const stickyHeaderScrollupCrossesInput =
            this.stickyHeaderElement &&
            this.stickyHeader.type === 'on-scroll-up' &&
            this.stickyHeader.height > inputTopBorder &&
            stickyHeaderBottomBorder > 0

          if (
            totalBarCrossesInput ||
            inputOutsideOfViewPort ||
            stickyHeaderCrossesInput ||
            stickyHeaderScrollupCrossesInput
          ) {
            this.scrollToCenter()
          }
        }
      }

      scrollToCenter () {
        this.variantListInput.scrollIntoView({
          block: 'center',
          behavior: 'smooth'
        })
      }

      switchVariants (event) {
        if (event.target.tagName !== 'INPUT') {
          return
        }

        this.variantListInput = event.target
        this.variantListInput.select()
        if (this.allInputsArray.length !== 1) {
          this.variantListInput.addEventListener('keydown', e => {
            if (e.key === 'Enter') {
              e.preventDefault()
              e.target.blur()
              if (this.validateInput(e.target)) {
                const currentIndex = this.allInputsArray.indexOf(e.target)
                this.lastKey = e.shiftKey
                if (!e.shiftKey) {
                  const nextIndex = currentIndex + 1
                  const nextVariant =
                    this.allInputsArray[nextIndex] || this.allInputsArray[0]
                  nextVariant.select()
                } else {
                  const previousIndex = currentIndex - 1
                  const previousVariant =
                    this.allInputsArray[previousIndex] ||
                    this.allInputsArray[this.allInputsArray.length - 1]
                  this.lastElement = previousVariant.dataset.index
                  previousVariant.select()
                }
              }
            }
          })

          this.scrollQuickOrderListTable()
        } else {
          this.variantListInput.addEventListener('keydown', e => {
            if (e.key === 'Enter') {
              e.preventDefault()
              e.target.blur()
            }
          })
        }
      }

      updateMultipleQty (items) {
        this.querySelector(
          '.variant-remove-total .loading__spinner'
        ).classList.remove('hidden')

        const body = JSON.stringify({
          updates: items,
          sections: this.getSectionsToRender().map(section => section.section),
          sections_url: this.getSectionsUrl()
        })

        this.updateMessage()
        this.setErrorMessage()

        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
          .then(response => {
            return response.text()
          })
          .then(state => {
            const parsedState = JSON.parse(state)
            this.renderSections(parsedState)
          })
          .catch(() => {
            this.setErrorMessage(window.cartStrings.error)
          })
          .finally(() => {
            this.querySelector(
              '.variant-remove-total .loading__spinner'
            ).classList.add('hidden')
          })
      }

      getSectionsUrl () {
        if (window.pageNumber) {
          return `${window.location.pathname}?page=${window.pageNumber}`
        } else {
          return `${window.location.pathname}`
        }
      }

      updateQuantity (id, quantity, name, action) {
        this.toggleLoading(id, true)
        this.cleanErrors()

        let routeUrl = routes.cart_change_url
        let body = JSON.stringify({
          quantity,
          id,
          sections: this.getSectionsToRender().map(section => section.section),
          sections_url: this.getSectionsUrl()
        })
        let fetchConfigType
        if (action === this.actions.add) {
          fetchConfigType = 'javascript'
          routeUrl = routes.cart_add_url
          body = JSON.stringify({
            items: [
              {
                quantity: parseInt(quantity),
                id: parseInt(id)
              }
            ],
            sections: this.getSectionsToRender().map(
              section => section.section
            ),
            sections_url: this.getSectionsUrl()
          })
        }

        this.updateMessage()
        this.setErrorMessage()

        fetch(`${routeUrl}`, { ...fetchConfig(fetchConfigType), ...{ body } })
          .then(response => {
            return response.text()
          })
          .then(state => {
            const parsedState = JSON.parse(state)
            const quantityElement = document.getElementById(`Quantity-${id}`)
            const items = document.querySelectorAll('.variant-item')

            if (parsedState.description || parsedState.errors) {
              const variantItem = document.querySelector(
                `[id^="Variant-${id}"] .variant-item__totals.small-hide .loading__spinner`
              )
              variantItem.classList.add('loading__spinner--error')
              this.resetQuantityInput(id, quantityElement)
              if (parsedState.errors) {
                this.updateLiveRegions(id, parsedState.errors)
              } else {
                this.updateLiveRegions(id, parsedState.description)
              }
              return
            }

            this.classList.toggle('is-empty', parsedState.item_count === 0)

            this.renderSections(parsedState, id)

            let hasError = false

            const currentItem = parsedState.items.find(
              item => item.variant_id === parseInt(id)
            )
            const updatedValue = currentItem ? currentItem.quantity : undefined
            if (updatedValue && updatedValue !== quantity) {
              this.updateError(updatedValue, id)
              hasError = true
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: this.quickOrderListId,
              cartData: parsedState
            })

            if (hasError) {
              this.updateMessage()
            } else if (action === this.actions.add) {
              this.updateMessage(parseInt(quantity))
            } else if (action === this.actions.update) {
              this.updateMessage(
                parseInt(quantity - quantityElement.dataset.cartQuantity)
              )
            } else {
              this.updateMessage(
                -parseInt(quantityElement.dataset.cartQuantity)
              )
            }
          })
          .catch(error => {
            this.querySelectorAll('.loading__spinner').forEach(overlay =>
              overlay.classList.add('hidden')
            )
            this.resetQuantityInput(id)
            console.error(error)
            this.setErrorMessage(window.cartStrings.error)
          })
          .finally(() => {
            this.toggleLoading(id)
            if (this.lastKey && this.lastElement === id) {
              this.querySelector(`#Variant-${id} input`).select()
            }
          })
      }

      resetQuantityInput (id, quantityElement) {
        const input =
          quantityElement ?? document.getElementById(`Quantity-${id}`)
        input.value = input.getAttribute('value')
      }

      setErrorMessage (message = null) {
        this.errorMessageTemplate =
          this.errorMessageTemplate ??
          document
            .getElementById(
              `QuickOrderListErrorTemplate-${this.dataset.productId}`
            )
            .cloneNode(true)
        const errorElements = document.querySelectorAll(
          '.quick-order-list-error'
        )

        errorElements.forEach(errorElement => {
          errorElement.innerHTML = ''
          if (!message) return
          const updatedMessageElement =
            this.errorMessageTemplate.cloneNode(true)
          updatedMessageElement.content.querySelector(
            '.quick-order-list-error-message'
          ).innerText = message
          errorElement.appendChild(updatedMessageElement.content)
        })
      }

      updateMessage (quantity = null) {
        const messages = this.querySelectorAll(
          '.quick-order-list__message-text'
        )
        const icons = this.querySelectorAll('.quick-order-list__message-icon')

        if (quantity === null || isNaN(quantity)) {
          messages.forEach(message => (message.innerHTML = ''))
          icons.forEach(icon => icon.classList.add('hidden'))
          return
        }

        const isQuantityNegative = quantity < 0
        const absQuantity = Math.abs(quantity)

        const textTemplate = isQuantityNegative
          ? absQuantity === 1
            ? window.quickOrderListStrings.itemRemoved
            : window.quickOrderListStrings.itemsRemoved
          : quantity === 1
          ? window.quickOrderListStrings.itemAdded
          : window.quickOrderListStrings.itemsAdded

        messages.forEach(
          msg =>
            (msg.innerHTML = textTemplate.replace('[quantity]', absQuantity))
        )

        if (!isQuantityNegative) {
          icons.forEach(i => i.classList.remove('hidden'))
        }
      }

      updateError (updatedValue, id) {
        let message = ''
        if (typeof updatedValue === 'undefined') {
          message = window.cartStrings.error
        } else {
          message = window.cartStrings.quantityError.replace(
            '[quantity]',
            updatedValue
          )
        }
        this.updateLiveRegions(id, message)
      }

      cleanErrors () {
        this.querySelectorAll('.desktop-row-error').forEach(error =>
          error.classList.add('hidden')
        )
        this.querySelectorAll(`.variant-item__error-text`).forEach(
          error => (error.innerHTML = '')
        )
      }

      updateLiveRegions (id, message) {
        const variantItemErrorDesktop = document.getElementById(
          `Quick-order-list-item-error-desktop-${id}`
        )
        const variantItemErrorMobile = document.getElementById(
          `Quick-order-list-item-error-mobile-${id}`
        )
        if (variantItemErrorDesktop) {
          variantItemErrorDesktop.querySelector(
            '.variant-item__error-text'
          ).innerHTML = message
          variantItemErrorDesktop.closest('tr').classList.remove('hidden')
        }
        if (variantItemErrorMobile)
          variantItemErrorMobile.querySelector(
            '.variant-item__error-text'
          ).innerHTML = message

        this.variantItemStatusElement.setAttribute('aria-hidden', true)

        const cartStatus = document.getElementById(
          'quick-order-list-live-region-text'
        )
        cartStatus.setAttribute('aria-hidden', false)

        setTimeout(() => {
          cartStatus.setAttribute('aria-hidden', true)
        }, 1000)
      }

      getSectionInnerHTML (html, selector) {
        return new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector(selector).innerHTML
      }

      toggleLoading (id, enable) {
        const quickOrderListItems = this.querySelectorAll(
          `#Variant-${id} .loading__spinner`
        )
        const quickOrderListItem = this.querySelector(`#Variant-${id}`)

        if (enable) {
          quickOrderListItem.classList.add(
            'quick-order-list__container--disabled'
          )
          ;[...quickOrderListItems].forEach(overlay =>
            overlay.classList.remove('hidden')
          )
          this.variantItemStatusElement.setAttribute('aria-hidden', false)
        } else {
          quickOrderListItem.classList.remove(
            'quick-order-list__container--disabled'
          )
          quickOrderListItems.forEach(overlay =>
            overlay.classList.add('hidden')
          )
        }
      }
    }
  )
}

/* recipient-form.js */
if (!customElements.get('recipient-form')) {
  customElements.define(
    'recipient-form',
    class RecipientForm extends HTMLElement {
      constructor () {
        super()
        this.recipientFieldsLiveRegion = this.querySelector(
          `#Recipient-fields-live-region-${this.dataset.sectionId}`
        )
        this.checkboxInput = this.querySelector(
          `#Recipient-checkbox-${this.dataset.sectionId}`
        )
        this.checkboxInput.disabled = false
        this.hiddenControlField = this.querySelector(
          `#Recipient-control-${this.dataset.sectionId}`
        )
        this.hiddenControlField.disabled = true
        this.emailInput = this.querySelector(
          `#Recipient-email-${this.dataset.sectionId}`
        )
        this.nameInput = this.querySelector(
          `#Recipient-name-${this.dataset.sectionId}`
        )
        this.messageInput = this.querySelector(
          `#Recipient-message-${this.dataset.sectionId}`
        )
        this.sendonInput = this.querySelector(
          `#Recipient-send-on-${this.dataset.sectionId}`
        )
        this.offsetProperty = this.querySelector(
          `#Recipient-timezone-offset-${this.dataset.sectionId}`
        )
        if (this.offsetProperty)
          this.offsetProperty.value = new Date().getTimezoneOffset().toString()

        this.errorMessageWrapper = this.querySelector(
          '.product-form__recipient-error-message-wrapper'
        )
        this.errorMessageList = this.errorMessageWrapper?.querySelector('ul')
        this.errorMessage =
          this.errorMessageWrapper?.querySelector('.error-message')
        this.defaultErrorHeader = this.errorMessage?.innerText
        this.currentProductVariantId = this.dataset.productVariantId
        this.addEventListener('change', this.onChange.bind(this))
        this.onChange()
      }

      cartUpdateUnsubscriber = undefined
      variantChangeUnsubscriber = undefined
      cartErrorUnsubscriber = undefined

      connectedCallback () {
        this.cartUpdateUnsubscriber = subscribe(
          PUB_SUB_EVENTS.cartUpdate,
          event => {
            if (
              event.source === 'product-form' &&
              event.productVariantId.toString() === this.currentProductVariantId
            ) {
              this.resetRecipientForm()
            }
          }
        )

        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          event => {
            if (event.data.sectionId === this.dataset.sectionId) {
              this.currentProductVariantId = event.data.variant.id.toString()
            }
          }
        )

        this.cartUpdateUnsubscriber = subscribe(
          PUB_SUB_EVENTS.cartError,
          event => {
            if (
              event.source === 'product-form' &&
              event.productVariantId.toString() === this.currentProductVariantId
            ) {
              this.displayErrorMessage(event.message, event.errors)
            }
          }
        )
      }

      disconnectedCallback () {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber()
        }

        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber()
        }

        if (this.cartErrorUnsubscriber) {
          this.cartErrorUnsubscriber()
        }
      }

      onChange () {
        if (this.checkboxInput.checked) {
          this.enableInputFields()
          this.recipientFieldsLiveRegion.innerText =
            window.accessibilityStrings.recipientFormExpanded
        } else {
          this.clearInputFields()
          this.disableInputFields()
          this.clearErrorMessage()
          this.recipientFieldsLiveRegion.innerText =
            window.accessibilityStrings.recipientFormCollapsed
        }
      }

      inputFields () {
        return [
          this.emailInput,
          this.nameInput,
          this.messageInput,
          this.sendonInput
        ]
      }

      disableableFields () {
        return [...this.inputFields(), this.offsetProperty]
      }

      clearInputFields () {
        this.inputFields().forEach(field => (field.value = ''))
      }

      enableInputFields () {
        this.disableableFields().forEach(field => (field.disabled = false))
      }

      disableInputFields () {
        this.disableableFields().forEach(field => (field.disabled = true))
      }

      displayErrorMessage (title, body) {
        this.clearErrorMessage()
        this.errorMessageWrapper.hidden = false
        if (typeof body === 'object') {
          this.errorMessage.innerText = this.defaultErrorHeader
          return Object.entries(body).forEach(([key, value]) => {
            const errorMessageId = `RecipientForm-${key}-error-${this.dataset.sectionId}`
            const fieldSelector = `#Recipient-${key}-${this.dataset.sectionId}`
            const message = `${value.join(', ')}`
            const errorMessageElement = this.querySelector(`#${errorMessageId}`)
            const errorTextElement =
              errorMessageElement?.querySelector('.error-message')
            if (!errorTextElement) return

            if (this.errorMessageList) {
              this.errorMessageList.appendChild(
                this.createErrorListItem(fieldSelector, message)
              )
            }

            errorTextElement.innerText = `${message}.`
            errorMessageElement.classList.remove('hidden')

            const inputElement = this[`${key}Input`]
            if (!inputElement) return

            inputElement.setAttribute('aria-invalid', true)
            inputElement.setAttribute('aria-describedby', errorMessageId)
          })
        }

        this.errorMessage.innerText = body
      }

      createErrorListItem (target, message) {
        const li = document.createElement('li')
        const a = document.createElement('a')
        a.setAttribute('href', target)
        a.innerText = message
        li.appendChild(a)
        li.className = 'error-message'
        return li
      }

      clearErrorMessage () {
        this.errorMessageWrapper.hidden = true

        if (this.errorMessageList) this.errorMessageList.innerHTML = ''

        this.querySelectorAll('.recipient-fields .form__message').forEach(
          field => {
            field.classList.add('hidden')
            const textField = field.querySelector('.error-message')
            if (textField) textField.innerText = ''
          }
        )
        ;[
          this.emailInput,
          this.messageInput,
          this.nameInput,
          this.sendonInput
        ].forEach(inputElement => {
          inputElement.setAttribute('aria-invalid', false)
          inputElement.removeAttribute('aria-describedby')
        })
      }

      resetRecipientForm () {
        if (this.checkboxInput.checked) {
          this.checkboxInput.checked = false
          this.clearInputFields()
          this.clearErrorMessage()
        }
      }
    }
  )
}

/* share.js */
if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends DetailsDisclosure {
      constructor () {
        super()

        this.elements = {
          shareButton: this.querySelector('button'),
          shareSummary: this.querySelector('summary'),
          closeButton: this.querySelector('.share-button__close'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input')
        }
        this.urlToShare = this.elements.urlInput
          ? this.elements.urlInput.value
          : document.location.href

        if (navigator.share) {
          this.mainDetailsToggle.setAttribute('hidden', '')
          this.elements.shareButton.classList.remove('hidden')
          this.elements.shareButton.addEventListener('click', () => {
            navigator.share({ url: this.urlToShare, title: document.title })
          })
        } else {
          this.mainDetailsToggle.addEventListener(
            'toggle',
            this.toggleDetails.bind(this)
          )
          this.mainDetailsToggle
            .querySelector('.share-button__copy')
            .addEventListener('click', this.copyToClipboard.bind(this))
          this.mainDetailsToggle
            .querySelector('.share-button__close')
            .addEventListener('click', this.close.bind(this))
        }
      }

      toggleDetails () {
        if (!this.mainDetailsToggle.open) {
          this.elements.successMessage.classList.add('hidden')
          this.elements.successMessage.textContent = ''
          this.elements.closeButton.classList.add('hidden')
          this.elements.shareSummary.focus()
        }
      }

      copyToClipboard () {
        navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
          this.elements.successMessage.classList.remove('hidden')
          this.elements.successMessage.textContent =
            window.accessibilityStrings.shareSuccess
          this.elements.closeButton.classList.remove('hidden')
          this.elements.closeButton.focus()
        })
      }

      updateUrl (url) {
        this.urlToShare = url
        this.elements.urlInput.value = url
      }
    }
  )
}

/* show-more.js */
if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      constructor () {
        super()
        const button = this.querySelector('button')
        button.addEventListener('click', event => {
          this.expandShowMore(event)
          const nextElementToFocus = event.target
            .closest('.parent-display')
            .querySelector('.show-more-item')
          if (
            nextElementToFocus &&
            !nextElementToFocus.classList.contains('hidden') &&
            nextElementToFocus.querySelector('input')
          ) {
            nextElementToFocus.querySelector('input').focus()
          }
        })
      }
      expandShowMore (event) {
        const parentDisplay = event.target
          .closest('[id^="Show-More-"]')
          .closest('.parent-display')
        const parentWrap = parentDisplay.querySelector('.parent-wrap')
        this.querySelectorAll('.label-text').forEach(element =>
          element.classList.toggle('hidden')
        )
        parentDisplay
          .querySelectorAll('.show-more-item')
          .forEach(item => item.classList.toggle('hidden'))
        if (!this.querySelector('.label-show-less')) {
          this.classList.add('hidden')
        }
      }
    }
  )
}

/* flickity-carousel.js */
if (!customElements.get('flickity-carousel')) {
  customElements.define(
    'flickity-carousel',
    class FlickityCarousel extends HTMLElement {
      constructor () {
        super();

        if (typeof window.Flickity === 'undefined') {
          return;
        }

        this.flickityOptions = {};
        this.flickity = null;

        if (Shopify.designMode) {
          this.addEventListener('shopify:section:load', this.init.bind(this));
          document.addEventListener('shopify:block:select', this.editorSelect.bind(this));
          document.addEventListener('shopify:block:deselect', this.editorDeselect.bind(this));
        }

        this.init();
      }

      init() {
        try {
          this.flickityOptions = JSON.parse(this.getAttribute('data-flickity-config'));

          if (this.flickity !== null) {
            this.flickity.destroy();
          }

          const flickity = new Flickity(this, this.flickityOptions);
          this.flickity = flickity;

          this.flickity.on('dragStart', () => this.flickity.slider.style.pointerEvents = 'none');
          this.flickity.on('dragEnd', () => this.flickity.slider.style.pointerEvents = 'auto');
          this.flickity.on('select', () => {
            for (let i = 0; i < this.flickity.cells.length; i++) {
              const cell = this.flickity.cells[i].element;
              if (i === this.flickity.selectedIndex) {
                cell.querySelector('video')?.play();
              } else {
                cell.querySelector('video')?.pause();
              }
            }
          });

          setTimeout(() => {
            this.flickity.resize();
          }, 100);
        } catch (error) {
          console.log('Error parsing Flickity options', error);
        }
      }

      editorSelect(event) {
        if (this.flickity) {
          const key = event.target.getAttribute('data-shopify-editor-block');
          for (let i = 0; i < this.flickity.cells.length; i++) {
            const cell = this.flickity.cells[i].element;
            if (cell.getAttribute('data-shopify-editor-block') === key) {
              if (this.flickityOptions.autoPlay)
                this.flickity.stopPlayer();

              this.flickity.select(i);
              break;
            }
          }
        }
      }

      editorDeselect() {
        if (this.flickity && this.flickityOptions.autoPlay) {
          this.flickity.playPlayer();
        }
      }
    }
  )
}

/* flickity-thumbnails.js */
if (!customElements.get('flickity-thumbnails')) {
  customElements.define(
    'flickity-thumbnails',
    class FlickityThumbnails extends HTMLElement {
      constructor () {
        super();

        this.carousel = this.previousElementSibling;
        this.flickity = null;
        this.prevButton = null;
        this.nextButton = null;

        if (!this.carousel || this.carousel.nodeName.toLowerCase() !== 'flickity-carousel' || !this.carousel.flickity) {
          return;
        }

        if (typeof window.Flickity !== 'undefined' && this.getAttribute('data-flickity-config')) {
          this.prevButton = this.querySelector('.slider-button--prev') || null;
          this.nextButton = this.querySelector('.slider-button--next') || null;

          if (Shopify.designMode) {
            this.addEventListener('shopify:section:load', this.initFlickity.bind(this));
          }

          this.initFlickity();
          this.handlePrevNextButtons();
        }

        this.carouselThumbnails = this.querySelectorAll('.slider__slide');
        this.carouselThumbnails.forEach(thumbnail => {
          thumbnail.addEventListener('click', this.handleThumbnailClick.bind(this));
        });
      }

      initFlickity() {
        let flickityOptions = {};

        try {
          flickityOptions = JSON.parse(this.getAttribute('data-flickity-config'));

          if (this.flickity !== null) {
            this.flickity.destroy();

            if (this.prevButton) {
              this.prevButton.removeEventListener('click', this.handlePreviousClick.bind(this));
            }

            if (this.nextButton) {
              this.nextButton.removeEventListener('click', this.handleNextClick.bind(this));
            }
          }

          const flickity = new Flickity(this, flickityOptions);
          this.flickity = flickity;

          if (this.prevButton) {
            this.prevButton.addEventListener('click', this.handlePreviousClick.bind(this));
          }

          if (this.nextButton) {
            this.nextButton.addEventListener('click', this.handleNextClick.bind(this));
          }

          setTimeout(() => {
            this.flickity.resize();
          }, 100);
        } catch (error) {
          console.log('Error parsing Flickity options', error);
        }
      }

      handlePrevNextButtons() {
        if (this.flickity.options.wrapAround) {
          return;
        }

        if (this.prevButton) {
          if (typeof this.flickity.slides !== 'undefined') {
            if (this.flickity.selectedSlide === this.flickity.slides[0]) {
              this.prevButton.setAttribute('disabled', '');
            } else {
              this.prevButton.removeAttribute('disabled');
            }
          }
        }

        if (this.nextButton) {
          if (typeof this.flickity.slides !== 'undefined') {
            if (this.flickity.selectedSlide === this.flickity.slides[this.flickity.slides.length - 1]) {
              this.nextButton.setAttribute('disabled', '');
            } else {
              this.nextButton.removeAttribute('disabled');
            }
          }
        }
      }

      handleThumbnailClick(event) {
        const thumbnail = event.currentTarget;
        let index = null;

        if (thumbnail.hasAttribute('data-target')) {
          const target = thumbnail.getAttribute('data-target');

          for (let i = 0; i < this.carousel.flickity.cells.length; i++) {
            const cell = this.carousel.flickity.cells[i].element;

            if (cell.getAttribute('data-media-id') === target) {
              index = i;
              break;
            }
          }
        } else if (thumbnail.hasAttribute('data-index')) {
          index = parseInt(thumbnail.getAttribute('data-index'));
        } else {
          return;
        }

        this.carousel.flickity.select(index);

        const selectedCell = this.carouselThumbnails[this.carousel.flickity.selectedIndex];
        const previousSelectedCell = this.querySelector('.thumbnail[aria-current="true"]');

        if (previousSelectedCell) {
          previousSelectedCell.removeAttribute('aria-current');
        }

        selectedCell.querySelector('.thumbnail').setAttribute('aria-current', 'true');

        const flickityAfter = window.getComputedStyle(this, '::after').content;
        const currentlyDestroyed = flickityAfter !== "none" && flickityAfter !== "flickity";

        if (this.flickity && typeof this.flickity.slides !== 'undefined' && !currentlyDestroyed) {
          this.flickity.selectCell(index, false);
          this.handlePrevNextButtons();
        } else {
          const scrollY = selectedCell.offsetTop - (this.clientHeight / 2) + (selectedCell.clientHeight / 2);
          this.scroll({ top: scrollY, behavior: 'smooth' });
        }
      }

      handleNextClick() {
        this.flickity.next();
        this.handlePrevNextButtons();
      }

      handlePreviousClick() {
        this.flickity.previous();
        this.handlePrevNextButtons();
      }
    }
  )
}

/* flickity-marquee.js */
if (!customElements.get('flickity-marquee')) {
  customElements.define(
    'flickity-marquee',
    class FlickityMarquee extends HTMLElement {
      constructor () {
        super();

        this.marquee = null;
        this.requestId = null;
        this.speed = -1.5;

        this.stopOnHover = false;

        if (this.hasAttribute('data-speed')) {
          try {
            this.speed = parseFloat(this.getAttribute('data-speed'));
          } catch (e) {
            console.warn(`Bad value was provided for speed: "${this.getAttribute('data-speed')}", expected value in float format.`);
          }
        }

        if (this.hasAttribute('data-stop-hover')) {
          this.stopOnHover = this.getAttribute('data-stop-hover') === 'true';
        }
      }

      connectedCallback() {
        this.style.setProperty('--initial-height', this.getBoundingClientRect().height + 'px');
        if (typeof window.Flickity !== 'undefined') {
          if (Shopify.designMode) {
            this.addEventListener('shopify:section:load', this.initFlickity.bind(this));
          }

          this.initFlickity();
        } else {
          console.error("Flickity is not loaded in, marquee cannot be initialized.");
        }
        
        if (this.stopOnHover) {
          this.addEventListener('mouseenter', this.pause.bind(this));
          this.addEventListener('mouseleave', this.play.bind(this));
        }
      }

      initFlickity() {
        if (this.marquee !== null) {
          this.pause();
          this.marquee.destroy();
        }

        this.marquee = new Flickity(this, {
          accessibility: true,
          resize: true,
          wrapAround: true,
          prevNextButtons: false,
          pageDots: false,
          percentPosition: true,
          setGallerySize: true,
        });

        
        setTimeout(() => {
          this.marquee.resize();
          this.play();
          if(window.innerWidth < 750) {
            this.play();
          } else {
            this.pause();
          }
  
          window.addEventListener('resize', function() {
            if(window.innerWidth < 750) {
              this.play();
            } else {
              this.pause();
            }
          }.bind(this));
        }, 100);
      }

      play() {
        this.marquee.x += this.speed;
        this.marquee.settle(this.marquee.x);
        this.pause();
        this.requestId = window.requestAnimationFrame(this.play.bind(this));
      }

      pause() {
        if (this.requestId) {
          window.cancelAnimationFrame(this.requestId);
          this.requestId = null;
        }
      }
    }
  )
}

class VolumePricing extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.inputs = this.querySelectorAll('input');
    this.parent = this.parentNode;

    if (this.inputs.length === 0 || !this.parent.querySelector('[name="quantity"]')) {
      return;
    }

    this.quantitySelector = this.parent.querySelector('[name="quantity"]');

    for (const input of this.inputs) {
      input.addEventListener('click', this.handleInputChange.bind(this));
    }
  }

  disconnectedCallback() {
    for (const input of this.inputs) {
      input.removeEventListener('click', this.handleInputChange.bind(this));
    }
  }

  handleInputChange(event) {
    const input = event.target;
    const quantity = input.value;

    this.quantitySelector.value = quantity;
    this.quantitySelector.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

customElements.define('volume-pricing', VolumePricing);

class SimpleAccordion extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      opener: '.simple-accordion--opener',
      content: '.simple-accordion--content'
    };

    this.opener = this.querySelector(`${ this.selectors.opener }`);
    this.content = this.querySelector(`${ this.selectors.content }`);
    this.openOnHover = this.hasAttribute('data-open-on-hover');

    this.parent = this.parentNode;
    if (this.hasAttribute('data-parent') && this.closest(this.getAttribute('data-parent')) !== null) {
      this.parent = this.closest(this.getAttribute('data-parent'));
    }

    this.oneOpen = false;
    if (this.hasAttribute('data-one-open')) {
      this.oneOpen = true;
    }

    this.opener.addEventListener('click', this.toggle.bind(this));

    if (this.openOnHover) {
      this.opener.addEventListener('mouseenter', this.open.bind(this));
      const leaveTarget = document.querySelector(this.getAttribute('data-open-on-hover')) !== null ? document.querySelector(this.getAttribute('data-open-on-hover')) : this;
      leaveTarget.addEventListener('mouseleave', this.close.bind(this));
    }
  }

  get siblings() {
    const siblings = [];
    const siblingAccordions = this.parent.querySelectorAll('simple-accordion');

    for (const accordion of siblingAccordions) {
      if (accordion !== this) {
        siblings.push(accordion);
      }
    }

    return siblings;
  }

  open() {
    this.opener.setAttribute('aria-expanded', 'true');
    this.content.setAttribute('aria-hidden', 'false');
    this.setAttribute('open', '');

    if (this.oneOpen) {
      this.closeSiblings();
    }

    if (this.hasAttribute('data-event') && document.querySelector(this.getAttribute('data-event'))) {
      document.querySelector(this.getAttribute('data-event')).dispatchEvent(new CustomEvent('accordionOpened'));
    }
  }

  close(indirect = true) {
    this.opener.setAttribute('aria-expanded', 'false');
    this.content.setAttribute('aria-hidden', 'true');
    this.removeAttribute('open', '');

    if (indirect) {
      if (this.hasAttribute('data-event') && document.querySelector(this.getAttribute('data-event'))) {
        document.querySelector(this.getAttribute('data-event')).dispatchEvent(new CustomEvent('accordionClosed'));
      }
    }
  }

  closeSiblings() {
    for (const sibling of this.siblings) {
      sibling.close(false);
    }
  }

  toggle() {
    if (this.opener.getAttribute('aria-expanded') === 'true') {
      this.close();
    } else {
      this.open();
    }
  }
}

customElements.define('simple-accordion', SimpleAccordion);

var FloatingAddToCart = class extends HTMLElement {
  constructor() {
    super();

    this.hiddenClass = 'floating-add-to-cart--hidden';
    this.buttonClass = 'floating-add-to-cart--button';
    this.spinnerClass = 'loading__spinner'

    this.productFormId = this.dataset['productFormId'];
    this.productForm = document.querySelector(`#${this.productFormId}`);
    this.productFormButton = this.productForm.querySelector('button[type="submit"]');
    this.productFormButtonSpinner = this.productFormButton.querySelector(`.${this.spinnerClass}`);

    this._intersectionObserver = null;
    this._mutationObserver = null;

    this.button = this.querySelector(`.${this.buttonClass}`);
    this.buttonSpinner = this.button.querySelector(`.${this.spinnerClass}`);

    this.button.addEventListener('click', this._addToCart.bind(this));

    this.button.disabled = this.productFormButton.disabled;
  }

  connectedCallback() {
    const closeBtn = this.querySelector(".icon-close");
    closeBtn.addEventListener("click", function() {
      this.classList.add("hide");
    }.bind(this));
    if (this._intersectionObserver === null) {
      let options = {
        root: null, // Defaults to viewport when null
        rootMargin: "0px",
        threshold: 0,
      };

      this._intersectionObserver = new IntersectionObserver(this._observerUpdate.bind(this), options);
      this._intersectionObserver.observe(this.productForm);
    }

    if (this._mutationObserver === null) {
      let options = {
        attributes: true,
        childList: false,
        subtree: false
      }

      this._mutationObserver = new MutationObserver(this._mutationUpdate.bind(this));
      this._mutationObserver.observe(this.productFormButton, options);
      this._mutationObserver.observe(this.productFormButtonSpinner, options);
    }
  }

  disconnectedCallback() {
    if (this._intersectionObserver !== null) {
      this._intersectionObserver.disconnect();
      this._intersectionObserver = null;
    }

    if (this._mutationObserver !== null) {
      this._mutationObserver.disconnect();
      this._mutationObserver = null;
    }
  }

  _observerUpdate(entries) {
    for (const entry of entries) {
      this._handleHide(entry.intersectionRatio !== 0);
    }
  }

  _mutationUpdate(entries) {
    for (const mutation of entries) {
      if (mutation.type === "attributes" && mutation.attributeName === 'class') {
        if (mutation.target.classList.contains(this.spinnerClass)) {
          this.buttonSpinner.className = mutation.target.className;
        } else {
          this.button.className = mutation.target.className;
          this.button.classList.add(this.buttonClass);
        }
      }
    }
  }

  _handleHide(shouldHide) {
    if (shouldHide) {
      this.classList.add(this.hiddenClass);
    } else {
      this.classList.remove(this.hiddenClass);
    }
  }

  _addToCart() {
    const customilyBtn = document.querySelector('#customily-cart-btn');
    if (customilyBtn) {
      customilyBtn.click();
    } else {
      this.productFormButton.click();
    }
  }
}

customElements.define('floating-add-to-cart', FloatingAddToCart);

class CartUpsell extends HTMLElement {
  constructor() {
    super();

    this.dynamicProduct = this.getAttribute('data-preload');

    if (this.dynamicProduct !== null) {
      this.init();
    }
  }

  async init() {
    const recommendations =
      await fetch(`${ window.Shopify.routes.root }recommendations/products?section_id=cart-upsell&product_id=${ this.dynamicProduct }&limit=1`)
        .then(response => response.text())
        .then(data => {
          return data;
        });

    const html = new DOMParser().parseFromString(recommendations, 'text/html');

    if (html.querySelector('[data-dynamic-content]')) {
      this.innerHTML = html.querySelector('[data-dynamic-content]').innerHTML;
      this.removeAttribute('data-preload');
      this.classList.remove('hidden');
    }
  }
}

window.customElements.define('cart-upsell', CartUpsell);

/* theme-editor.js */
function hideProductModal () {
  const productModal = document.querySelectorAll('product-modal[open]');
  productModal && productModal.forEach(modal => modal.hide());
}

document.addEventListener('shopify:block:select', function (event) {
  hideProductModal();
  const blockSelectedIsSlide = event.target.classList.contains('slideshow__slide');
  if (!blockSelectedIsSlide) return;

  const parentSlideshowComponent = event.target.closest('slideshow-component');
  if (parentSlideshowComponent) {
    parentSlideshowComponent.pause();
  
    setTimeout(function () {
      parentSlideshowComponent.slider.scrollTo({
        left: event.target.offsetLeft
      });
    }, 200);
  }
})

document.addEventListener('shopify:block:deselect', function (event) {
  const blockDeselectedIsSlide =
    event.target.classList.contains('slideshow__slide')
  if (!blockDeselectedIsSlide) return
  const parentSlideshowComponent = event.target.closest('slideshow-component')
  if (parentSlideshowComponent && parentSlideshowComponent.autoplayButtonIsSetToPlay)
    parentSlideshowComponent.play()
})

document.addEventListener('shopify:section:load', () => {
  hideProductModal()
  const zoomOnHoverScript = document.querySelector('[id^=EnableZoomOnHover]')
  if (!zoomOnHoverScript) return
  if (zoomOnHoverScript) {
    const newScriptTag = document.createElement('script')
    newScriptTag.src = zoomOnHoverScript.src
    zoomOnHoverScript.parentNode.replaceChild(newScriptTag, zoomOnHoverScript)
  }
})

document.addEventListener('shopify:section:reorder', () => hideProductModal())

document.addEventListener('shopify:section:select', () => hideProductModal())

document.addEventListener('shopify:section:deselect', () => hideProductModal())

document.addEventListener('shopify:inspector:activate', () =>
  hideProductModal()
)

document.addEventListener('shopify:inspector:deactivate', () =>
  hideProductModal()
)
